/* Drippy PDP v2 — loaded only by templates/product.v2.json.
   Cosmetic work on the theme's native radio picker so no theme snippet has to
   be forked:
     1. "Size" -> "Choose size: 6 inch", kept in sync with the selection.
     2. "6 inch / 15 cm" -> 6" on the first line, 15 cm small underneath.
        That is what lets the boxes sit four to a row instead of two.
   Values that are not "<n> inch / <n> cm" (8mm studs, for example) are left
   exactly as the theme rendered them. */
(function () {
  // Option values are typed inconsistently in the admin — "8.5 inch / 21.5 cm",
  // "8,5 inch / 21 cm", "8.5inch / 21cm", "24 inch / 61cm" all occur.
  // 2026-10-13: also "7 inch / 18 cm (5.5 Carat)" (Moissanite Tennis 3mm); the carat note is dropped from the button
  var SIZE_RE = /^\s*([\d]+(?:[.,][\d]+)?)\s*(?:inch|in|")\s*\/\s*([\d]+(?:[.,][\d]+)?)\s*cm\s*(?:\([^)]*\))?\s*$/i;
  /* 2026-10-02 · unit order by market (Johannes): inches first in the US, UK
     and Canada, centimetres first everywhere else (EU etc.). Only the display
     changes; variant names stay "7 inch / 18 cm". Ring sizes don't match the
     pattern and are left alone. */
  var INCH_FIRST = /^(US|GB|CA)$/.test((window.Shopify && window.Shopify.country) || document.documentElement.getAttribute('data-country') || '');
  /* QA round 2: the written-out label ("Choose size: 18 cm / 7 inch") used the
     English unit and decimal point in every language. */
  var LANG = (document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
  var INCH_WORD = { de: 'Zoll', fr: 'pouces', it: 'pollici', es: 'pulgadas', pt: 'polegadas', sv: 'tum', da: 'tommer', nl: 'inch' }[LANG] || 'inch';
  var DEC = LANG === 'en' ? '.' : ',';
  function sizeParts(m) {
    var inch = m[1].replace(',', '.'), cm = m[2].replace(',', '.');
    var li = inch.replace('.', DEC), lc = cm.replace('.', DEC);
    // One unit per market (Johannes 2026-10-10): inch in US/GB/CA, cm everywhere else.
    return INCH_FIRST ? { big: li + '"', small: lc + ' cm', line: li + ' ' + INCH_WORD }
                      : { big: lc + ' cm', small: li + '"', line: lc + ' cm' };
  }

  /* Strings this file writes into the picker. Rendered by the product template
     into window.PDP_V2_T from locales/src/drippy.<loc>.json; the English
     fallbacks keep the script working if that block is ever dropped. */
  function T(key, fallback) {
    var d = window.PDP_V2_T;
    return (d && typeof d[key] === 'string' && d[key]) || fallback;
  }

  function firstTextNode(el) {
    for (var i = 0; i < el.childNodes.length; i++) {
      var n = el.childNodes[i];
      if (n.nodeType === 3 && n.textContent.trim() !== '') return n;
    }
    return null;
  }

  /* The theme's sticky bar clones the whole buy column into <floated-form>,
     duplicating every id this template renders — including the size-guide
     drawer. getElementById would then hand back whichever copy the parser saw
     first, which is how a click on SIZE GUIDE started opening a drawer that
     was hidden inside the bar. Always take the copy outside the bar. */
  function real(selector) {
    var all = document.querySelectorAll(selector);
    for (var i = 0; i < all.length; i++) {
      if (!all[i].closest || !all[i].closest('.product__popup')) return all[i];
    }
    return all[0] || null;
  }

  function splitLabel(label) {
    if (label.dataset.v2Split) return;
    var node = firstTextNode(label);
    if (!node) return;
    var m = node.textContent.match(SIZE_RE);
    if (!m) {
      label.dataset.v2Split = 'plain';
      return;
    }
    var sp = sizeParts(m);
    var inch = document.createElement('span');   // the big number (inch or cm, by market)
    inch.className = 'v2-size__inch';
    inch.textContent = sp.big;
    var cm = document.createElement('span');     // the small one underneath
    cm.className = 'v2-size__cm';
    cm.textContent = sp.small;
    label.replaceChild(cm, node);
    label.insertBefore(inch, cm);
    label.dataset.v2Split = 'split';
  }

  /* "Finish: <dot> White Gold" and "Choose size: 6 inch / 15 cm" are the same
     shape: a bold label and a plain value. Built as nodes rather than innerHTML
     so an option value is never parsed as markup. */
  function setGroupName(el, label, value) {
    var vm = value && String(value).match(SIZE_RE);
    if (vm) value = sizeParts(vm).line;
    if (el.dataset.v2Name === label + '|' + value) return;
    el.textContent = '';
    var l = document.createElement('span');
    l.className = 'v2-optionlabel';
    // French typography puts a no-break space before the colon (2026-10-10)
    l.textContent = label + (/^fr/.test(document.documentElement.lang || '') ? '\u00a0:' : ':');
    el.appendChild(l);
    if (value) {
      var v = document.createElement('span');
      v.className = 'v2-optionvalue';
      v.textContent = value;
      el.appendChild(v);
    }
    el.dataset.v2Name = label + '|' + value;
  }

  /* "7 inch / 18 cm" and "7 inch" and "7" all have to compare equal, and the
     admin spells some values "8,5 inch / 21 cm" or "8.5inch / 21cm". */
  function normalizeSize(value) {
    var v = (value || '').replace(/,/g, '.').toLowerCase().trim();
    var m = v.match(/^([\d.]+)\s*(?:inch|in|")/);
    if (m) return m[1] + ' inch';
    return v;
  }

  /* The "What's included" card shows the piece at the selected variant's price
     (moissanite studs run 119-149), so it follows the main price element. */
  function syncPiecePrice() {
    var target = document.querySelector('[data-v2-piece-price]');
    var source = document.querySelector('.v2-titlerow__price .price .money');
    if (!target || !source) return;
    var text = source.textContent.trim();
    if (text && target.textContent.trim() !== text) target.textContent = text;
  }

  function markPopular(nameEl, selected) {
    /* 2026-10-09: the "Most popular" pill is retired (no popularity stats in
       copy); it was only hidden by CSS. Remove any copy and stop here. */
    var old = nameEl.querySelector('.v2-pill');
    if (old) old.remove();
    if (true) return;
    var src = real('.v2-popular-src');
    var popular = src && src.dataset.v2Popular;
    var existing = nameEl.querySelector('.v2-pill');
    if (!popular || normalizeSize(selected) !== normalizeSize(popular)) {
      if (existing) existing.remove();
      return;
    }
    if (existing) return;
    /* "MOST POPULAR" needs 111px, and at 375px the whole row (label 83 + value
       87 + pill + size guide 60 + gaps) only has 335px to live in. Below 990px
       the short form is shown instead of letting the row wrap — two separate
       strings because no locale shortens by dropping a leading word. */
    var pill = document.createElement('span');
    pill.className = 'v2-pill';
    var long = document.createElement('span');
    long.className = 'v2-pill__long';
    long.textContent = T('most_popular', 'Most popular');
    var short = document.createElement('span');
    short.className = 'v2-pill__short';
    short.textContent = T('popular_short', 'popular');
    pill.appendChild(long);
    pill.appendChild(short);
    nameEl.appendChild(pill);
  }

  /* Groups the theme labels itself (Color) get the same treatment. */
  function styleOtherGroupName(fieldset) {
    if (fieldset.querySelector('.size-guide-btn')) return;
    // 2026-10-15 · set rows and the matching-piece offer paint their own heading (pdp-v2-set.js)
    if (fieldset.closest('[data-set-picker], [data-set-offer]')) return;
    var name = fieldset.querySelector('.product-form__group-name');
    if (!name) return;
    var raw = name.textContent.replace(/\s+/g, ' ').trim();
    if (!raw) return;
    var i = raw.indexOf(':');
    var label = i === -1 ? raw : raw.slice(0, i);
    var value = i === -1 ? '' : raw.slice(i + 1).trim();
    if (!value) {
      var checked = fieldset.querySelector('input[type="radio"]:checked');
      value = checked ? checked.value : '';
    }
    setGroupName(name, label, value);
  }

  function sizeFieldsets() {
    return document.querySelectorAll(
      '.product__info-container .product-parameters .product-form__controls'
    );
  }

  /* The size guide opener sits *after* the options in the markup, but it has to
     render on the same line as the label. Wrapping the two in a header element
     is what lets each option group lay itself out independently — placing them
     on a grid broke as soon as a product had two option groups (Color + Size),
     because both groups' parts landed in the same two grid rows and overlapped. */
  function wrapHead(fieldset) {
    if (fieldset.querySelector(':scope > .v2-optionhead')) return;
    var name = fieldset.querySelector(':scope > .product-form__group-name');
    if (!name) return;
    var head = document.createElement('div');
    head.className = 'v2-optionhead';
    fieldset.insertBefore(head, name);
    head.appendChild(name);
    var opener = fieldset.querySelector(':scope > modal-opener');
    if (opener) head.appendChild(opener);
  }

  /* Two products carry a Color option with exactly one value ("14K Gold",
     "White Gold"). The theme renders it as an image swatch, and with no variant
     image behind it that draws a broken-image icon with nothing to choose. The
     finish row already states the finish, so drop the group. */
  function hideDeadSwatchGroup(fieldset) {
    var inputs = fieldset.querySelectorAll('input[type="radio"]');
    var swatch = fieldset.querySelector('.variant-swatch, .color-swatch');
    if (inputs.length === 1 && swatch) fieldset.hidden = true;
  }

  /* The theme's image swatches draw the variant's featured image as a
     background, falling back to a grey placeholder SVG when there is none —
     which is every colour option in this catalogue, so they rendered as broken
     image tiles. Turn those into ordinary text boxes using the radio's value. */
  function textifyEmptySwatches(fieldset) {
    var labels = fieldset.querySelectorAll('label.variant-swatch');
    for (var i = 0; i < labels.length; i++) {
      var label = labels[i];
      if (label.dataset.v2Textified) continue;
      var bg = getComputedStyle(label).backgroundImage || '';
      if (bg.indexOf('data:image/svg') === -1 && bg !== 'none') continue;
      var input = document.getElementById(label.getAttribute('for'));
      if (!input || !input.value) continue;
      label.classList.remove('variant-swatch');
      label.style.backgroundImage = 'none';
      label.insertBefore(document.createTextNode(input.value), label.firstChild);
      label.dataset.v2Textified = '1';
    }
  }

  function paint() {
    var sets = sizeFieldsets();
    for (var i = 0; i < sets.length; i++) {
      wrapHead(sets[i]);
      textifyEmptySwatches(sets[i]);
      hideDeadSwatchGroup(sets[i]);
      styleOtherGroupName(sets[i]);
    }

    for (var i = 0; i < sets.length; i++) {
      var fieldset = sets[i];
      var name = fieldset.querySelector('.product-form__group-name');
      if (!name || !fieldset.querySelector('.size-guide-btn')) continue;

      var checked = fieldset.querySelector('input[type="radio"]:checked');
      setGroupName(name, T('choose_size_short', 'Choose size'), checked ? checked.value : '');
      markPopular(name, checked ? checked.value : '');
      syncPiecePrice();

      var labels = fieldset.querySelectorAll('input[type="radio"] + label');
      for (var j = 0; j < labels.length; j++) splitLabel(labels[j]);
    }
  }

  /* ---- Size guide drawer ----
     The theme's SIZE GUIDE button belongs to its own <modal-opener>. Rather
     than fork that snippet, the click is caught in the capture phase on
     document — which always runs before listeners bound to the button itself —
     and routed to our drawer instead. Where no drawer exists for the product
     type (earrings are sized in mm), the button is hidden. */
  function sizeGuide() {
    var root = real('#v2-size-guide');
    var btn = document.querySelector('.product__info-container .size-guide-btn');

    if (!root) {
      if (btn) (btn.closest('modal-opener') || btn).hidden = true;
      return;
    }

    // The drawer is authored inside the buy column, but .product__info-container
    // is position:sticky with z-index:10, so it opens its own stacking context
    // and the theme header (z-index 12) paints over the drawer. Move it to the
    // body so the drawer's own z-index actually applies.
    if (root.parentNode !== document.body) document.body.appendChild(root);

    var lastFocus = null;

    // 2026-10-02 · the measuring videos had preload="none" and no poster, so
    // the tab opened on an empty black box (Johannes: "doesn't load"). When a
    // tab with a video is shown it now loads and plays muted on a loop, like a
    // GIF; the controls stay for sound and scrubbing.
    function wakeVideos(scope) {
      var vs = scope.querySelectorAll('video');
      for (var i = 0; i < vs.length; i++) {
        var v = vs[i];
        v.muted = true; v.loop = true; v.setAttribute('playsinline', '');
        if (v.preload === 'none') { v.preload = 'auto'; v.load(); }
        (function (v) {
          function go() { if (!root.hidden && v.offsetParent !== null && v.paused) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); } }
          go();
          v.addEventListener('canplay', go, { once: true });   // first time: play once it has loaded
        })(v);
      }
    }
    function pauseVideos(scope) {
      var vs = scope.querySelectorAll('video');
      for (var i = 0; i < vs.length; i++) vs[i].pause();
    }

    function open(start) {
      lastFocus = document.activeElement;
      root.hidden = false;
      var shown = root.querySelectorAll('[data-sg-panel]:not([hidden])');
      for (var k = 0; k < shown.length; k++) wakeVideos(shown[k]);
      document.documentElement.classList.add('v2-sg-open');
      if (typeof root.v2SgOnOpen === 'function') root.v2SgOnOpen(start);
      var panel = root.querySelector('.v2-sg__panel');
      if (panel) panel.focus();
    }

    function close() {
      root.hidden = true;
      document.documentElement.classList.remove('v2-sg-open');
      var v = root.querySelectorAll('video');
      for (var i = 0; i < v.length; i++) v[i].pause();
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    // 2026-10-10 · bracelet guide (Johannes, approved mockup), replacing the
    // typed wrist calculator of 2026-10-04: a wrist slider, a to-scale line
    // drawing of the wrist with the bracelet dotted around it, pills for only
    // the sizes this bracelet has (from the page's own size radios), one fit
    // line and a Pick button. Moving the slider picks the smallest size with
    // at least 0.3 cm (0.12 in) of room; a pill tap overrides that.
    (function () {
      var box = root.querySelector('[data-sg-br]');
      if (!box) return;
      var range = box.querySelector('[data-sg-br-range]'), val = box.querySelector('[data-sg-br-val]');
      var pills = box.querySelector('[data-sg-br-pills]'), text = box.querySelector('[data-sg-br-text]');
      var roomEl = box.querySelector('[data-sg-br-room]'), pick = box.querySelector('[data-sg-br-pick]');
      var wristEl = box.querySelector('[data-sg-br-wrist]'), bandEl = box.querySelector('[data-sg-br-band]');
      var rows = [].slice.call(root.querySelectorAll('.v2-sg__table--wrist tbody tr'));
      var S = {}, tpl = box.querySelector('[data-sg-strings]');
      if (tpl && tpl.content) [].slice.call(tpl.content.querySelectorAll('[data-k]')).forEach(function (n) { S[n.dataset.k] = n.textContent; });
      var inch = box.dataset.unit === 'in', dec = box.dataset.dec || '.';
      var UNIT = inch ? ' in' : ' cm';   // 2026-10-11 Johannes: picks follow the size table rows (tableOpt), no fixed room rule
      var K = 26, CX = 120, CY = 90, RATIO = 1.45;   // drawing units per cm; wrist cross-section width : depth
      var opts = [], cur = null, touched = false;
      function n1(x) { return (Math.round(x * 10) / 10).toFixed(1).replace('.', dec); }
      function num(x) { return parseFloat(String(x).replace(',', '.')); }
      function sizeInputs() {
        var all = [].slice.call(document.querySelectorAll('.product__info-container .product-parameters input[type=radio]'))
          .filter(function (i) { return !i.closest('.product__popup'); });
        var seen = {}, out = [];
        all.forEach(function (i) {
          var m = String(i.value).match(SIZE_RE);
          if (!m) return;
          var o = { input: i, inch: num(m[1]), cm: num(m[2]) };
          if (seen[o.inch]) return;
          seen[o.inch] = 1; out.push(o);
        });
        return out.sort(function (a, b) { return a.inch - b.inch; });
      }
      // 2026-10-10 (Johannes): the table lists only the sizes this bracelet
      // comes in. A size that is missing hands its wrists to the next size up,
      // so the ranges still join up and nobody wonders about in-between sizes.
      function fitRows(have) {
        if (!have.length) return;
        var known = rows.filter(function (r) { return have.indexOf(parseFloat(r.dataset.inch)) > -1; });
        if (!known.length) return;
        var prev = -1;
        rows.forEach(function (r, i) {
          var td = r.cells[0];
          if (!r.dataset.origMin) { r.dataset.origMin = r.dataset.min; r.dataset.origText = td.textContent; }
          var keep = known.indexOf(r) > -1;
          r.hidden = !keep;
          if (!keep) return;
          var from = rows[prev + 1];
          r.dataset.min = from.dataset.origMin;
          var lead = (from.dataset.origText || from.cells[0].textContent).match(/^\s*[\d.,]+/);
          td.textContent = lead ? r.dataset.origText.replace(/^\s*[\d.,]+/, lead[0]) : r.dataset.origText;
          prev = i;
        });
      }
      function sv(o) { return inch ? o.inch : o.cm; }           // size in the market's unit
      function label(o) { return inch ? String(o.inch).replace('.', dec) + '"' : String(o.cm).replace('.', dec) + ' cm'; }
      function wrist() { return num(range.value); }
      // 2026-10-11 Johannes: the pick is the size table's own row for this wrist
      // (rows hold cm; fitRows already hands missing sizes' wrists upward)
      function tableOpt(w) {
        var c = inch ? Math.round(w * 2.54 * 10) / 10 : w, best = null;
        rows.forEach(function (r) {
          if (r.hidden || num(r.dataset.min) > c + 1e-9) return;
          var o = opts.filter(function (x) { return x.inch === parseFloat(r.dataset.inch); })[0];
          if (o) best = o;
        });
        return best;
      }
      // Ramanujan's ellipse perimeter for semi-axes 1 and 1/RATIO
      var F = (function () { var a = 1, b = 1 / RATIO; return Math.PI * (3 * (a + b) - Math.sqrt((3 * a + b) * (a + 3 * b))); })();
      function draw(wCm, bCm) {
        var a = wCm / F, b = a / RATIO, d = (bCm - wCm) / (2 * Math.PI);
        wristEl.setAttribute('rx', (a * K).toFixed(2)); wristEl.setAttribute('ry', (b * K).toFixed(2));
        bandEl.setAttribute('rx', (Math.max(0.3, a + d) * K).toFixed(2)); bandEl.setAttribute('ry', (Math.max(0.3, b + d) * K).toFixed(2));
      }
      function show(o) {
        cur = o;
        var w = wrist();
        val.textContent = n1(w) + UNIT;
        range.setAttribute('aria-valuetext', n1(w) + UNIT);
        [].slice.call(pills.children).forEach(function (b) { b.setAttribute('aria-pressed', String(parseFloat(b.dataset.inch) === o.inch)); });
        var room = Math.round((sv(o) - w) * 10) / 10;
        var roomCm = inch ? room * 2.54 : room;
        roomEl.textContent = room >= 0 ? (S.room || '[n] room').replace('[n]', '+' + n1(room) + UNIT) : '−' + n1(-room) + UNIT;
        // "one size up / down" only when that size exists and would fit better:
        // past the largest size it says so; when the size below would be too
        // tight, a roomy pick is still the best fit (sizes a whole inch apart).
        var i = opts.indexOf(o), up = opts[i + 1], down = opts[i - 1];
        var t = tableOpt(w) || opts[0], ti = opts.indexOf(t);
        var k = (i < ti || room < 0) ? (up ? 'tight' : 'big') : roomCm <= 1.4 + 1e-9 ? 'close' : roomCm <= 2.4 + 1e-9 ? 'relaxed'
          : !down ? 'small' : i > ti ? 'loose' : 'relaxed';
        text.textContent = S[k] || '';
        draw(inch ? w * 2.54 : w, inch ? o.inch * 2.54 : o.cm);
        rows.forEach(function (r) { r.classList.toggle('is-match', parseFloat(r.dataset.inch) === o.inch); });
        pick.textContent = (S.pick || 'Pick [size]').replace('[size]', label(o));
      }
      function auto() {
        if (!opts.length) return;
        var w = wrist();
        show(tableOpt(w) || opts[0]);
      }
      function build() {
        opts = sizeInputs();
        fitRows(opts.map(function (o) { return o.inch; }));
        // the chart's cm follows this product's own size names (9" is 22 cm on
        // some bracelets, 23 cm on others)
        opts.forEach(function (o) {
          var r = rows.filter(function (x) { return parseFloat(x.dataset.inch) === o.inch; })[0];
          if (!r || !r.cells[1]) return;
          var c = r.cells[1];
          if (!c.dataset.orig) c.dataset.orig = c.innerHTML;
          c.innerHTML = c.dataset.orig.replace(/\d+(?:[.,]\d+)?(\s*cm)/, String(o.cm).replace('.', dec) + '$1');
        });
        pills.innerHTML = '';
        if (!opts.length) { box.hidden = true; return; }
        box.hidden = false;
        opts.forEach(function (o) {
          var b = document.createElement('button');
          b.type = 'button'; b.dataset.inch = o.inch; b.textContent = label(o);
          b.setAttribute('aria-pressed', 'false');
          b.addEventListener('click', function () { show(o); });
          pills.appendChild(b);
        });
        if (touched) { auto(); return; }
        // default: the wrist that fits the size already chosen on the page, else 17 cm
        var on = opts.filter(function (o) { return o.input.checked; })[0];
        if (!on) {
          var chk = document.querySelectorAll('.product__info-container .product-parameters input[type=radio]:checked');
          for (var i = 0; i < chk.length && !on; i++) {
            if (chk[i].closest('.product__popup')) continue;
            var m = String(chk[i].value).match(SIZE_RE);
            if (m) on = opts.filter(function (o) { return o.inch === num(m[1]); })[0];
          }
        }
        var w = on ? sv(on) - (inch ? 0.4 : 1.0) : (inch ? 6.7 : 17);
        w = Math.min(num(range.max), Math.max(num(range.min), w));
        range.value = String(Math.round(w * 10) / 10);
        if (on) show(on); else auto();
      }
      range.addEventListener('input', function () { touched = true; auto(); });
      build();
      root.v2SgOnOpen = build;
      pick.addEventListener('click', function () {
        if (!cur) return;
        var l = document.querySelector('label[for="' + cur.input.id + '"]');
        if (l) l.click(); else cur.input.click();
        close();
      });
    })();

    // 2026-10-13 · "Vind je maat" (Johannes, approved preview after the drunk
    // grandma test). Bracelets only. One question per screen, every step drawn,
    // a slider for the measurement and a result that picks the size on the page.
    // Wrist -> size follows the live size table (missing sizes hand their wrists
    // to the next size up); a bracelet that fits -> the smallest size not tighter
    // than it (0.5 cm slack). Above the biggest size: contact, never a forced size.
    // The measurement is remembered (not for gifts) and fills in the size on the
    // next bracelet, but only while the shopper has not picked one themselves.
    (function () {
      var box = root.querySelector('[data-sgf]');
      if (!box) return;
      var KEY = 'drippy:sgf';
      var S = {}, tpl = box.querySelector('[data-sgf-strings]');
      if (tpl && tpl.content) [].slice.call(tpl.content.querySelectorAll('[data-k]')).forEach(function (n) { S[n.dataset.k] = n.textContent; });
      var inch = box.dataset.unit === 'in', dec = box.dataset.dec || '.', U = inch ? 2.54 : 1;
      var rows = [].slice.call(box.querySelectorAll('.v2-sg__table--wrist tbody tr'));
      var title = root.querySelector('.v2-sg__title'), backBtn = root.querySelector('[data-sgf-back]');
      var hist = [], ctx = {}, opts = [], prow = [];
      function num(x) { return parseFloat(String(x).replace(',', '.')); }
      function fmt(cm) { var v = cm / U; return (Math.round(v * 10) / 10).toString().replace('.', dec) + (inch ? ' in' : ' cm'); }
      function label(o) { return inch ? String(o.inch).replace('.', dec) + '"' : String(o.cm).replace('.', dec) + ' cm'; }
      function sizeInputs() {
        var all = [].slice.call(document.querySelectorAll('.product__info-container .product-parameters input[type=radio]'))
          .filter(function (i) { return !i.closest('.product__popup'); });
        var seen = {}, out = [];
        all.forEach(function (i) {
          var m = String(i.value).match(SIZE_RE);
          if (!m) return;
          var o = { input: i, inch: num(m[1]), cm: num(m[2]) };
          if (seen[o.inch]) return;
          seen[o.inch] = 1; out.push(o);
        });
        return out.sort(function (a, b) { return a.inch - b.inch; });
      }
      // product rows: this bracelet's sizes with the wrist range each one covers
      function build() {
        opts = sizeInputs(); prow = [];
        var from = null;
        rows.forEach(function (r) {
          if (from === null) from = num(r.dataset.min);
          var o = opts.filter(function (x) { return x.inch === parseFloat(r.dataset.inch); })[0];
          if (!r.dataset.origText) r.dataset.origText = r.cells[0].textContent;
          if (!o) { r.hidden = true; return; }
          r.hidden = false;
          prow.push({ o: o, min: from, max: num(r.dataset.max), row: r });
          // the table shows the merged range, as the slider guide did
          var first = rows.filter(function (x) { return num(x.dataset.min) === from; })[0] || r;
          var m = (first.dataset.origText || '').match(/^\s*[\d.,]+/);
          r.cells[0].textContent = m ? r.dataset.origText.replace(/^\s*[\d.,]+/, m[0]) : r.dataset.origText;
          var c = r.cells[1]; if (!c.dataset.orig) c.dataset.orig = c.innerHTML;
          c.innerHTML = c.dataset.orig.replace(/\d+(?:[.,]\d+)?(\s*cm)/, String(o.cm).replace('.', dec) + '$1');
          from = null;
        });
        return prow.length > 0;
      }
      function forWrist(cm) {
        if (cm > prow[prow.length - 1].max + 1e-9) return null;
        var hit = prow[0];
        prow.forEach(function (p) { if (cm >= p.min - 1e-9) hit = p; });
        return { o: hit.o, small: cm < prow[0].min - 1e-9 };
      }
      function forBracelet(cm) {
        if (cm > opts[opts.length - 1].cm + 0.5) return null;
        for (var i = 0; i < opts.length; i++) if (opts[i].cm >= cm - 0.5) return { o: opts[i], small: cm < opts[0].cm - 1 };
        return { o: opts[opts.length - 1], small: false };
      }
      function biggest() { return label(opts[opts.length - 1]); }

      // ---- slider with a ruler that grows with it ----
      var RANGE = { wrist: inch ? [5, 10, 0.1, 6.7] : [13, 25, 0.1, 17], bracelet: inch ? [5, 10.5, 0.1, 7.5] : [13, 26, 0.1, 19] };
      function slider(kind) {
        var host = box.querySelector('[data-sgf-slider="' + kind + '"]');
        if (!host || host.dataset.built) return;
        host.dataset.built = '1';
        var R = RANGE[kind], lo = R[0], hi = R[1], W = 310 / (hi - lo), t = '', lab = '';
        for (var v = Math.ceil(lo); v <= hi + 1e-9; v++) {
          var x = 10 + (v - lo) * W;
          t += '<path d="M' + x.toFixed(1) + ' 60v' + (v % 2 ? 7 : 12) + '" stroke="currentColor" stroke-width="1.2"/>';
          if (v % 2 === 0 || inch) lab += '<text x="' + x.toFixed(1) + '" y="86" font-size="10" text-anchor="middle" fill="currentColor">' + v + '</text>';
        }
        var bar = kind === 'bracelet'
          ? '<rect data-bar x="10" y="34" width="0" height="7" rx="3.5" fill="#C9A24A"/>'
          : '<rect data-bar x="10" y="31" width="0" height="13" rx="2" fill="#F1E4C4" stroke="#B79C5E" stroke-width="1.2"/>';
        host.className = 'v2-sgf__sl';
        host.innerHTML = '<p class="v2-sgf__val"><output data-out></output></p>' +
          '<svg class="v2-sgf__ruler" viewBox="0 0 330 96" aria-hidden="true"><rect x="2" y="54" width="326" height="40" rx="4" fill="#fff" stroke="currentColor" stroke-width="1.3"/>' + t + lab + bar +
          '<path data-mark d="M10 26v24" stroke="#C0392B" stroke-width="2.4" stroke-linecap="round"/></svg>' +
          '<input type="range" class="v2-sgf__range" min="' + lo + '" max="' + hi + '" step="' + R[2] + '" value="' + R[3] + '" aria-label="' + (S.slider || '') + '" data-sg-noswipe>' +
          '<p class="v2-sgf__ends"><span>' + String(lo).replace('.', dec) + (inch ? ' in' : ' cm') + '</span><span>' + String(hi).replace('.', dec) + (inch ? ' in' : ' cm') + '</span></p>';
        var inp = host.querySelector('input'), out = host.querySelector('[data-out]'), b = host.querySelector('[data-bar]'), mk = host.querySelector('[data-mark]');
        function upd() {
          var v = num(inp.value), w = (v - lo) * W;
          ctx[kind] = v * U;
          out.textContent = String(Math.round(v * 10) / 10).replace('.', dec) + (inch ? ' in' : ' cm');
          inp.setAttribute('aria-valuetext', out.textContent);
          b.setAttribute('width', w.toFixed(1)); mk.setAttribute('d', 'M' + (10 + w).toFixed(1) + ' 26v24');
          inp.style.setProperty('--p', ((v - lo) / (hi - lo) * 100) + '%');
          live(kind);
        }
        inp.addEventListener('input', upd); upd();
      }
      /* 2026-10-14 (Johannes): no separate result screen. The sizes of this bracelet show
         right under the ruler with yours marked, and the button picks it and closes. */
      function live(kind) {
        var host = box.querySelector('[data-sgf-slider="' + kind + '"]'); if (!host) return;
        var fit = host.querySelector('[data-live-fit]');
        if (!fit) { fit = document.createElement('div'); fit.className = 'v2-sgf__fit v2-sgf__fit--live'; fit.setAttribute('data-live-fit', ''); host.appendChild(fit); }
        var cm = ctx[kind], hit = kind === 'wrist' ? forWrist(cm) : forBracelet(cm);
        fit.innerHTML = '';
        opts.forEach(function (o) { var d = document.createElement('span'); d.textContent = label(o); if (hit && o === hit.o) d.className = 'is-me'; fit.appendChild(d); });
        var btn = box.querySelector('[data-sgf-show="' + kind + '"]');
        if (btn) { if (!btn.dataset.orig) btn.dataset.orig = btn.textContent; btn.textContent = hit ? (S.pick || 'Pick [size]').replace('[size]', label(hit.o)) : btn.dataset.orig; }
      }

      // ---- steps ----
      function show(step) {
        [].slice.call(box.querySelectorAll('[data-sgf-step]')).forEach(function (s) { s.hidden = s.dataset.sgfStep !== step; });
        if (title) title.textContent = step === 'table' ? box.dataset.tTable : box.dataset.tFinder;
        if (backBtn) backBtn.hidden = hist.length < 2;
        if (step === 'bracelet' || step === 'wrist') slider(step);
        box.scrollTop = 0;
      }
      function go(step) { hist.push(step); show(step); }
      function result(hit, why, est) {
        hist.push('result');
        var me = S[ctx.gift ? 'gift' : 'me'] || '';
        box.querySelector('[data-sgf-lbl]').textContent = me;
        box.querySelector('[data-sgf-big]').textContent = label(hit.o);
        box.querySelector('[data-sgf-why-out]').textContent = why + (est ? ' ' + (S.est || '') : '') + (hit.small ? ' ' + (S.small || '') : '');
        var fit = box.querySelector('[data-sgf-fit]'); fit.innerHTML = '';
        opts.forEach(function (o) { var d = document.createElement('span'); d.textContent = label(o); if (o === hit.o) d.className = 'is-me'; fit.appendChild(d); });
        var pick = box.querySelector('[data-sgf-pick]');
        pick.textContent = (S.pick || 'Pick [size]').replace('[size]', label(hit.o));
        pick.onclick = function () {
          choose(hit.o, false);
          if (!ctx.gift && ctx.save) { try { localStorage.setItem(KEY, JSON.stringify(ctx.save)); localStorage.setItem('drippy:pick-bracelet', String(hit.o.cm)); } catch (e) {} }
          close();
        };
        show('result');
      }
      function tooBig(why) {
        hist.push('big');
        box.querySelector('[data-sgf-big-out]').textContent = why + ' ' + (S.big_b || '').replace('[size]', biggest());
        show('big');
      }

      box.addEventListener('click', function (e) {
        var t = e.target, g = t.closest('[data-sgf-go]');
        if (g) {
          if (g.hasAttribute('data-sgf-reset')) { hist = []; ctx = {}; }
          if (g.hasAttribute('data-sgf-gift')) ctx.gift = true;
          go(g.dataset.sgfGo); return;
        }
        var q = t.closest('[data-sgf-guess]');
        if (q) { var h = forWrist(num(q.dataset.sgfGuess)); if (h) result(h, q.dataset.sgfWhy, true); return; }
        var s = t.closest('[data-sgf-show]');
        if (s) {
          var kind = s.dataset.sgfShow, cm = ctx[kind];
          var why = (S[kind === 'wrist' ? 'why_w' : 'why_br'] || '').replace('[n]', fmt(cm));
          var hit = kind === 'wrist' ? forWrist(cm) : forBracelet(cm);
          ctx.save = { k: kind, cm: cm };
          if (!hit) { tooBig(why); return; }
          choose(hit.o, false);
          if (!ctx.gift) { try { localStorage.setItem(KEY, JSON.stringify(ctx.save)); localStorage.setItem('drippy:pick-bracelet', String(hit.o.cm)); } catch (e) {} }
          close();
        }
      });
      if (backBtn) backBtn.addEventListener('click', function () { hist.pop(); var p = hist[hist.length - 1]; if (p) show(p); });

      root.v2SgOnOpen = function (start) {
        if (!build()) { hist = ['table']; show('table'); return; }
        hist = []; ctx = {};
        go(start === 'finder' ? 'who' : 'table');
      };

      // ---- the line under the sizes ----
      var line = null, picked = null;
      function choose(o, saved) {
        var l = document.querySelector('label[for="' + o.input.id + '"]');
        if (l) l.click(); else o.input.click();
        picked = { o: o, saved: saved };
        paintLine();
      }
      function paintLine() {
        if (!line) return;
        var stillOn = picked && picked.o.input.checked;
        line.innerHTML = '';
        if (stillOn) {
          line.className = 'v2-sgf-line is-set';
          var ck = document.createElement('span'); ck.className = 'v2-sgf-line__ck'; ck.setAttribute('aria-hidden', 'true'); ck.textContent = '✓';
          var tx = document.createElement('span'); tx.textContent = (S[picked.saved ? 'saved' : 'yours'] || '').replace('[size]', label(picked.o));
          var ch = document.createElement('button'); ch.type = 'button'; ch.setAttribute('data-sg-open', 'finder'); ch.textContent = S.change || '';
          line.appendChild(ck); line.appendChild(tx); line.appendChild(ch);
        } else {
          line.className = 'v2-sgf-line';
          var bt = document.createElement('button'); bt.type = 'button'; bt.setAttribute('data-sg-open', 'finder');
          bt.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="2.5" y="8" width="19" height="8" rx="1.5" fill="none" stroke="currentColor" stroke-width="1.5"/><path d="M6 8v3M9.5 8v4M13 8v3M16.5 8v4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';
          var q1 = document.createElement('span'); q1.textContent = S.cta_q || '';
          var a1 = document.createElement('b'); a1.textContent = S.cta_a || '';
          bt.appendChild(q1); bt.appendChild(a1); line.appendChild(bt);
        }
      }
      function mountLine() {
        if (!build()) return;
        var any = opts[0].input, fs = any.closest('.product-form__controls');
        if (!fs || fs.classList.contains('d-single')) return;
        line = document.createElement('div');
        fs.parentNode.insertBefore(line, fs.nextSibling);
        fs.addEventListener('change', function () { setTimeout(paintLine, 0); });
        paintLine();
        // remembered measurement: only fills in while nothing is picked yet.
        // Waits for the page to finish loading, the theme clears the size
        // radios while it initialises and would undo an earlier pick.
        function applyMem() {
          var mem = null;
          try { mem = JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) {}
          if (!mem || !mem.cm || !build()) return;
          if (opts.some(function (o) { return o.input.checked; })) return;
          var hit = mem.k === 'wrist' ? forWrist(mem.cm) : forBracelet(mem.cm);
          if (hit && !hit.o.input.disabled) choose(hit.o, true);
        }
        if (document.readyState === 'complete') setTimeout(applyMem, 600);
        else window.addEventListener('load', function () { setTimeout(applyMem, 600); });
      }
      mountLine();
    })();

    // 2026-10-04 · ring calculator: finger circumference or the inside
    // diameter of a ring that fits, in mm. Picks the smallest size whose
    // circumference fits, then the size this ring actually comes in (plain
    // "9" or a range like "M: 6-6.5"), next size up when it is missing.
    (function () {
      var box = root.querySelector('[data-sg-calc][data-kind="ring"]');
      if (!box) return;
      var input = box.querySelector('input'), res = box.querySelector('[data-sg-res]'), text = box.querySelector('[data-sg-text]');
      var lab = box.querySelector('.v2-sg__calclabel'), dec = box.dataset.dec || '.';
      var rows = [].slice.call(root.querySelectorAll('.v2-sg__table--ring tbody tr'));
      var S = {}, tpl = box.querySelector('[data-sg-strings]');
      if (tpl && tpl.content) [].slice.call(tpl.content.querySelectorAll('[data-k]')).forEach(function (n) { S[n.dataset.k] = n.textContent; });
      var mode = 'circ', picked = null;
      function num(x) { return parseFloat(String(x).replace(',', '.')); }
      function fmt(x) { return (Math.round(x * 10) / 10).toFixed(1).replace('.', dec); }
      function sizeInputs() {
        var all = [].slice.call(document.querySelectorAll('.product__info-container .product-parameters input[type=radio]'));
        var vis = all.filter(function (i) { var l = document.querySelector('label[for="' + i.id + '"]'); return l && l.offsetParent !== null; });
        return (vis.length ? vis : all).map(function (i) {
          var m = String(i.value).match(/(\d+(?:[.,]\d+)?)(?:\s*-\s*(\d+(?:[.,]\d+)?))?/);
          return m ? { input: i, lo: num(m[1]), hi: m[2] ? num(m[2]) : num(m[1]), name: String(i.value) } : null;
        }).filter(Boolean).sort(function (a, b) { return a.lo - b.lo; });
      }
      [].slice.call(box.querySelectorAll('[data-sg-mode]')).forEach(function (b) {
        b.addEventListener('click', function () {
          mode = b.dataset.sgMode;
          [].slice.call(box.querySelectorAll('[data-sg-mode]')).forEach(function (o) { o.setAttribute('aria-pressed', String(o === b)); });
          lab.textContent = mode === 'diam' ? lab.dataset.lDiam : lab.dataset.lCirc;
          input.placeholder = mode === 'diam' ? '18' : '57';
          update();
        });
      });
      function update() {
        var v = num(input.value);
        rows.forEach(function (r) { r.classList.remove('is-match'); });
        if (!v || !rows.length) { res.hidden = true; picked = null; return; }
        var circ = mode === 'diam' ? v * Math.PI : v;
        var note = '';
        // a little slack (0.6 mm) so a measurement right on a size keeps that size
        var row = rows.filter(function (r) { return num(r.dataset.circ) >= circ - 0.6; })[0];
        if (!row) { row = rows[rows.length - 1]; note = S.big || ''; }
        else if (row === rows[0] && circ < num(rows[0].dataset.circ) - 2.6) note = S.small || '';
        row.classList.add('is-match');
        var want = num(row.dataset.size);
        var opts = sizeInputs();
        var exact = opts.filter(function (o) { return want >= o.lo && want <= o.hi; })[0];
        var up = opts.filter(function (o) { return o.lo > want; })[0];
        picked = exact || up || opts[opts.length - 1] || null;
        if (!picked) { res.hidden = true; return; }
        if (!exact && up && !note) note = S.up || '';
        text.innerHTML = '';
        var t = document.createElement('span'); t.textContent = (S.your || 'Your size') + ' '; text.appendChild(t);
        var b = document.createElement('b'); b.textContent = picked.name; text.appendChild(b);
        var prow = picked.lo === picked.hi ? rows.filter(function (r) { return num(r.dataset.size) === picked.lo; })[0] : null;
        if (prow) { var c = document.createElement('span'); c.textContent = ' · ' + fmt(num(prow.dataset.circ)) + ' mm'; text.appendChild(c); }
        if (note) { var n = document.createElement('small'); n.textContent = note; text.appendChild(n); }
        res.hidden = false;
      }
      input.addEventListener('input', update);
      box.querySelector('[data-sg-pick]').addEventListener('click', function () {
        if (!picked) return;
        var l = document.querySelector('label[for="' + picked.input.id + '"]');
        if (l) l.click(); else picked.input.click();
        close();
      }, true);
    })();

    // 2026-10-10 · earring guide (Johannes, approved mockup): one stud drawn
    // to scale on the ear, pills for the sizes this product has, one line per
    // size and a button that picks it. Sizes come from the page's own radios,
    // so "5mm / 0.5 Carat" shows as 5 mm and only real sizes appear.
    (function () {
      var box = root.querySelector('[data-sg-ear]');
      if (!box) return;
      var pills = box.querySelector('[data-sg-ear-pills]'), text = box.querySelector('[data-sg-ear-text]');
      var pick = box.querySelector('[data-sg-ear-pick]');
      var stud = box.querySelector('[data-sg-ear-stud]'), hl = box.querySelector('[data-sg-ear-hl]');
      var dec = box.dataset.dec || '.', PX = 3.6;   // drawing units per mm (lobe of about 20 mm = 72)
      var S = {}, tpl = box.querySelector('[data-sg-strings]');
      if (tpl && tpl.content) [].slice.call(tpl.content.querySelectorAll('[data-k]')).forEach(function (n) { S[n.dataset.k] = n.textContent; });
      // 2026-10-10: the stud is now a photo (img) sized in % of the ear photo
      var isImg = stud && stud.tagName === 'IMG', PCT = isImg ? parseFloat(stud.dataset.pctMm) || 1.78 : 0;
      var MAP = {}; try { MAP = JSON.parse(box.dataset.earMap || '{}'); } catch (e) {}
      function vis(n) { var v = MAP[String(n)]; return typeof v === 'number' ? v : n; }   // size on the ear, not the option
      var cx = (isImg || !stud) ? 0 : parseFloat(stud.getAttribute('cx')), cy = (isImg || !stud) ? 0 : parseFloat(stud.getAttribute('cy'));
      var opts = [], cur = null;
      function mm(v) {
        var m = String(v).replace(/,/g, '.').match(/(\d+(?:\.\d+)?)\s*(mm|cm)\b/i);
        if (!m) return null;
        var n = parseFloat(m[1]);
        return /cm/i.test(m[2]) ? Math.round(n * 100) / 10 : n;
      }
      function label(n) { return String(n).replace('.', dec) + ' mm'; }
      function bucket(n) {
        return n <= 3.5 ? 's3' : n < 4.5 ? 's4' : n < 5.5 ? 's5' : n < 7.25 ? 's6' : n < 8.5 ? 's8' : n < 9.75 ? 's9' : 's10';
      }
      function read() {
        var all = [].slice.call(document.querySelectorAll('.product__info-container .product-parameters input[type=radio]'))
          .filter(function (i) { return !i.closest('.product__popup'); });
        var seen = {}, out = [];
        all.forEach(function (i) {
          var n = mm(i.value);
          if (n === null || seen[n]) return;
          seen[n] = 1; out.push({ input: i, mm: n });
        });
        return out.sort(function (a, b) { return a.mm - b.mm; });
      }
      function show(o) {
        cur = o;
        [].slice.call(pills.children).forEach(function (b) { b.setAttribute('aria-pressed', String(parseFloat(b.dataset.mm) === o.mm)); });
        if (!stud) {
          // hoop photo: nothing to scale
        } else if (isImg) {
          stud.style.width = (vis(o.mm) * PCT).toFixed(2) + '%';
        } else {
          var r = o.mm / 2 * PX;
          stud.setAttribute('r', r.toFixed(2));
          hl.setAttribute('cx', (cx - r * 0.32).toFixed(2));
          hl.setAttribute('cy', (cy - r * 0.32).toFixed(2));
          hl.setAttribute('r', Math.max(1, r * 0.26).toFixed(2));
        }
        text.textContent = S[bucket(vis(o.mm))] || '';
        pick.textContent = (S.pick || 'Pick [size]').replace('[size]', label(o.mm));
      }
      function build() {
        opts = read();
        pills.innerHTML = '';
        opts.forEach(function (o) {
          var b = document.createElement('button');
          b.type = 'button'; b.dataset.mm = o.mm; b.textContent = label(o.mm);
          b.setAttribute('aria-pressed', 'false');
          b.addEventListener('click', function () { show(o); });
          pills.appendChild(b);
        });
        if (!opts.length) { box.hidden = true; return; }
        // the size already chosen on the page, otherwise the middle one
        var on = opts.filter(function (o) {
          var all = document.querySelectorAll('.product__info-container .product-parameters input[type=radio]:checked');
          for (var i = 0; i < all.length; i++) if (!all[i].closest('.product__popup') && mm(all[i].value) === o.mm) return true;
          return false;
        })[0];
        show(on || opts[Math.floor((opts.length - 1) / 2)]);
      }
      build();
      root.v2SgOnOpen = build;
      pick.addEventListener('click', function () {
        if (!cur) return;
        var l = document.querySelector('label[for="' + cur.input.id + '"]');
        if (l) l.click(); else cur.input.click();
        close();
      });
    })();

    // 2026-10-10 · chain guide (Johannes, approved mockup): Men / Women, a worn
    // photo of the selected length with the length drawn on as a pill, pills
    // for only this product's lengths (from the page's size radios, one unit
    // per market), one line per length and a Pick button. Photos exist for men
    // at 41/45/51/55/61 cm and women at 41/45/51 cm; any other length uses the
    // nearest photo for that gender, and women's lengths above 51 cm use the
    // nearest men's photo with a "shown on a men's model" note.
    (function () {
      var box = root.querySelector('[data-sg-ch]');
      if (!box) return;
      var pills = box.querySelector('[data-sg-ch-pills]'), text = box.querySelector('[data-sg-ch-text]');
      var note = box.querySelector('[data-sg-ch-note]'), pick = box.querySelector('[data-sg-ch-pick]');
      var img = box.querySelector('[data-sg-ch-img]'), tag = box.querySelector('[data-sg-ch-tag]');
      var segs = [].slice.call(box.querySelectorAll('[data-sg-ch-g]'));
      var S = {}, tpl = box.querySelector('[data-sg-strings]');
      if (tpl && tpl.content) [].slice.call(tpl.content.querySelectorAll('[data-k]')).forEach(function (n) { S[n.dataset.k] = n.textContent; });
      var inch = box.dataset.unit === 'in', dec = box.dataset.dec || '.';
      var g = box.dataset.g === 'w' ? 'w' : 'm';
      var PHOTOS = { m: [41, 45, 51, 55, 61], w: [41, 45, 51] };
      var opts = [], cur = null, warmed = {};
      function num(x) { return parseFloat(String(x).replace(',', '.')); }
      function nearest(list, cm) {
        return list.reduce(function (a, b) { return Math.abs(b - cm) < Math.abs(a - cm) ? b : a; });
      }
      function photo(gg, cm) {
        if (gg === 'w' && cm > 51) return { k: 'm' + nearest(PHOTOS.m, cm), men: true };
        return { k: gg + nearest(PHOTOS[gg], cm), men: false };
      }
      function src(k) { return box.getAttribute('data-p-' + k) || ''; }
      function bucket(cm) { return cm < 43 ? 41 : cm < 48.5 ? 45 : cm < 53 ? 51 : cm < 58.5 ? 55 : 61; }
      function label(o) { return inch ? String(o.inch).replace('.', dec) + '"' : String(o.cm).replace('.', dec) + ' cm'; }
      function read() {
        var all = [].slice.call(document.querySelectorAll('.product__info-container .product-parameters input[type=radio]'))
          .filter(function (i) { return !i.closest('.product__popup'); });
        var seen = {}, out = [];
        all.forEach(function (i) {
          var m = String(i.value).match(SIZE_RE);
          if (!m) return;
          var o = { input: i, inch: num(m[1]), cm: num(m[2]) };
          if (seen[o.cm]) return;
          seen[o.cm] = 1; out.push(o);
        });
        return out.sort(function (a, b) { return a.cm - b.cm; });
      }
      // load this product's photos for both genders once, so switching is instant
      function warm() {
        opts.forEach(function (o) {
          ['m', 'w'].forEach(function (gg) {
            var k = photo(gg, o.cm).k;
            if (warmed[k]) return;
            warmed[k] = 1; var im = new Image(); im.src = src(k);
          });
        });
      }
      function show(o) {
        cur = o;
        segs.forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.sgChG === g)); });
        [].slice.call(pills.children).forEach(function (b) { b.setAttribute('aria-pressed', String(num(b.dataset.cm) === o.cm)); });
        var p = photo(g, o.cm), s = src(p.k);
        if (s && img.getAttribute('src') !== s) img.setAttribute('src', s);
        img.alt = (S.alt || '').replace('[size]', label(o));
        tag.textContent = label(o);
        text.textContent = S[g + bucket(o.cm)] || '';
        note.textContent = p.men ? (S.men_note || '') : '';
        note.hidden = !p.men;
        pick.textContent = (S.pick || 'Pick [size]').replace('[size]', label(o));
      }
      function build() {
        opts = read();
        pills.innerHTML = '';
        if (!opts.length) { box.hidden = true; return; }
        box.hidden = false;
        opts.forEach(function (o) {
          var b = document.createElement('button');
          b.type = 'button'; b.dataset.cm = o.cm; b.textContent = label(o);
          b.setAttribute('aria-pressed', 'false');
          b.addEventListener('click', function () { show(o); });
          pills.appendChild(b);
        });
        // the length already chosen on the page, otherwise the one nearest 51 cm (20")
        var chk = document.querySelectorAll('.product__info-container .product-parameters input[type=radio]:checked');
        var on = null;
        for (var i = 0; i < chk.length && !on; i++) {
          if (chk[i].closest('.product__popup')) continue;
          var m = String(chk[i].value).match(SIZE_RE);
          if (m) on = opts.filter(function (o) { return o.cm === num(m[2]); })[0] || null;
        }
        if (!on) on = opts.reduce(function (a, b) { return Math.abs(b.cm - 51) < Math.abs(a.cm - 51) ? b : a; });
        show(on);
        if (!root.hidden) warm();
      }
      segs.forEach(function (b) {
        b.addEventListener('click', function () { g = b.dataset.sgChG === 'w' ? 'w' : 'm'; if (cur) show(cur); });
      });
      build();
      root.v2SgOnOpen = build;
      pick.addEventListener('click', function () {
        if (!cur) return;
        var l = document.querySelector('label[for="' + cur.input.id + '"]');
        if (l) l.click(); else cur.input.click();
        close();
      });
    })();

    // 2026-10-13 · "Vind je kettinglengte" (Johannes, approved preview). Chains
    // with lengths: measure a chain that falls nicely (nearest length we sell,
    // ties go longer), or tap the worn photo of where it should fall, then the
    // T-shirt size question (XL or bigger = one length longer, a broad neck lifts
    // a chain). The approved photo guide stays as the "Maattabel" view. The chosen
    // length is remembered and only fills in when this chain has exactly that
    // length and nothing is picked yet.
    (function () {
      var box = root.querySelector('[data-sgfc]');
      if (!box) return;
      var KEY = 'drippy:sgf-ch';
      var S = {}, tpl = box.querySelector('[data-sgf-strings]');
      if (tpl && tpl.content) [].slice.call(tpl.content.querySelectorAll('[data-k]')).forEach(function (n) { S[n.dataset.k] = n.textContent; });
      var inch = box.dataset.unit === 'in', dec = box.dataset.dec || '.', U = inch ? 2.54 : 1;
      var g = box.dataset.g === 'w' ? 'w' : 'm';
      var PHOTOS = { m: [41, 45, 51, 55, 61], w: [41, 45, 51] };
      var title = root.querySelector('.v2-sg__title'), backBtn = root.querySelector('[data-sgf-back]');
      var hist = [], ctx = {}, opts = [];
      function num(x) { return parseFloat(String(x).replace(',', '.')); }
      function label(o) { return inch ? String(o.inch).replace('.', dec) + '"' : String(o.cm).replace('.', dec) + ' cm'; }
      function nearest(list, cm) { return list.reduce(function (a, b) { return Math.abs(b - cm) < Math.abs(a - cm) ? b : a; }); }
      function bucket(cm) { return cm < 43 ? 41 : cm < 48.5 ? 45 : cm < 53 ? 51 : cm < 58.5 ? 55 : 61; }
      function photo(cm) {
        if (g === 'w' && cm > 51) return { src: box.getAttribute('data-p-m' + nearest(PHOTOS.m, cm)), men: true };
        return { src: box.getAttribute('data-p-' + g + nearest(PHOTOS[g], cm)), men: false };
      }
      function read() {
        var all = [].slice.call(document.querySelectorAll('.product__info-container .product-parameters input[type=radio]'))
          .filter(function (i) { return !i.closest('.product__popup'); });
        var seen = {}, out = [];
        all.forEach(function (i) {
          var m = String(i.value).match(SIZE_RE);
          if (!m) return;
          var o = { input: i, inch: num(m[1]), cm: num(m[2]) };
          if (seen[o.cm]) return;
          seen[o.cm] = 1; out.push(o);
        });
        opts = out.sort(function (a, b) { return a.cm - b.cm; });
        return opts.length > 0;
      }
      function nearestOpt(cm) {
        var best = opts[0];
        opts.forEach(function (o) { var d = Math.abs(o.cm - cm), bd = Math.abs(best.cm - cm); if (d < bd - 1e-9 || (Math.abs(d - bd) < 1e-9 && o.cm > best.cm)) best = o; });
        return best;
      }
      function setGift() {
        [].slice.call(box.querySelectorAll('[data-sgf-me]')).forEach(function (n) { n.hidden = !!ctx.gift; });
        [].slice.call(box.querySelectorAll('[data-sgf-gifted]')).forEach(function (n) { n.hidden = !ctx.gift; });
      }

      // ---- slider ----
      function slider() {
        var host = box.querySelector('[data-sgf-slider="chain"]');
        if (!host || host.dataset.built) return;
        host.dataset.built = '1';
        var lo = inch ? 14 : 35, hi = inch ? 28 : 70, step = 0.1, start = inch ? 20 : 51, W = 310 / (hi - lo), t = '', lab = '', every = inch ? 2 : 5;
        for (var v = lo; v <= hi + 1e-9; v++) {
          var x = 10 + (v - lo) * W, big = v % every === 0;
          t += '<path d="M' + x.toFixed(1) + ' 60v' + (big ? 12 : 6) + '" stroke="currentColor" stroke-width="' + (big ? 1.2 : 1) + '"/>';
          if (big) lab += '<text x="' + x.toFixed(1) + '" y="86" font-size="10" text-anchor="middle" fill="currentColor">' + v + '</text>';
        }
        host.className = 'v2-sgf__sl';
        host.innerHTML = '<p class="v2-sgf__val"><output data-out></output></p>' +
          '<svg class="v2-sgf__ruler" viewBox="0 0 330 96" width="330" height="96" aria-hidden="true"><rect x="2" y="54" width="326" height="40" rx="4" fill="#fff" stroke="currentColor" stroke-width="1.3"/>' + t + lab +
          '<rect data-bar x="10" y="36" width="0" height="5" rx="2.5" fill="#9a9a9a"/><path data-mark d="M10 26v24" stroke="#C0392B" stroke-width="2.4" stroke-linecap="round"/></svg>' +
          '<input type="range" class="v2-sgf__range" min="' + lo + '" max="' + hi + '" step="' + step + '" value="' + start + '" aria-label="' + (S.slider || '') + '" data-sg-noswipe>' +
          '<p class="v2-sgf__ends"><span>' + lo + (inch ? ' in' : ' cm') + '</span><span>' + hi + (inch ? ' in' : ' cm') + '</span></p>';
        var inp = host.querySelector('input'), out = host.querySelector('[data-out]'), b = host.querySelector('[data-bar]'), mk = host.querySelector('[data-mark]');
        function upd() {
          var v = num(inp.value), w = (v - lo) * W;
          ctx.len = v * U;
          out.textContent = String(Math.round(v * 10) / 10).replace('.', dec) + (inch ? ' in' : ' cm');
          inp.setAttribute('aria-valuetext', out.textContent);
          b.setAttribute('width', w.toFixed(1)); mk.setAttribute('d', 'M' + (10 + w).toFixed(1) + ' 26v24');
          inp.style.setProperty('--p', ((v - lo) / (hi - lo) * 100) + '%');
        }
        inp.addEventListener('input', upd); upd();
      }
      function looks() {
        var host = box.querySelector('[data-sgf-looks]');
        host.innerHTML = '';
        opts.forEach(function (o) {
          var b = document.createElement('button'), p = photo(o.cm);
          b.type = 'button'; b.className = 'v2-sgf__look';
          var im = document.createElement('img'); im.src = p.src; im.alt = ''; im.width = 440; im.height = 245; im.loading = 'lazy';
          var tx = document.createElement('span'), bb = document.createElement('b'), sm = document.createElement('small');
          bb.textContent = S['fall' + bucket(o.cm)] || ''; sm.textContent = label(o);
          tx.appendChild(bb); tx.appendChild(sm); b.appendChild(im); b.appendChild(tx);
          b.addEventListener('click', function () { ctx.look = o; go('tee'); });
          host.appendChild(b);
        });
      }

      function show(step) {
        [].slice.call(box.querySelectorAll('[data-sgf-step]')).forEach(function (s) { s.hidden = s.dataset.sgfStep !== step; });
        if (title) title.textContent = step === 'table' ? box.dataset.tTable : box.dataset.tFinder;
        if (backBtn) backBtn.hidden = hist.length < 2;
        if (step === 'measure') slider();
        if (step === 'look') looks();
        setGift();
        box.scrollTop = 0;
      }
      function go(step) { hist.push(step); show(step); }
      function result(o, why) {
        hist.push('result');
        box.querySelector('[data-sgf-lbl]').textContent = S[ctx.gift ? 'gift' : 'me'] || '';
        box.querySelector('[data-sgf-big]').textContent = label(o);
        var p = photo(o.cm), im = box.querySelector('[data-sgf-shot]');
        im.src = p.src; box.querySelector('[data-sgf-shot-tag]').textContent = label(o);
        box.querySelector('[data-sgf-why-out]').textContent = why + (p.men ? ' ' + (S.men_note || '') : '');
        var fit = box.querySelector('[data-sgf-fit]'); fit.innerHTML = '';
        opts.forEach(function (x) { var d = document.createElement('span'); d.textContent = label(x); if (x === o) d.className = 'is-me'; fit.appendChild(d); });
        var pick = box.querySelector('[data-sgf-pick]');
        pick.textContent = (S.pick || 'Pick [size]').replace('[size]', label(o));
        pick.onclick = function () {
          choose(o, false);
          if (!ctx.gift) { try { localStorage.setItem(KEY, JSON.stringify({ cm: o.cm })); localStorage.setItem('drippy:pick-chain', String(o.cm)); } catch (e) {} }
          close();
        };
        show('result');
      }
      function tooLong(why) {
        hist.push('big');
        box.querySelector('[data-sgf-big-out]').textContent = why + ' ' + (S.big_b || '').replace('[size]', label(opts[opts.length - 1]));
        show('big');
      }
      function fmtLen(cm) { var v = cm / U; return String(Math.round(v * 2) / 2).replace('.', dec) + (inch ? ' in' : ' cm'); }

      box.addEventListener('click', function (e) {
        var t = e.target, gg = t.closest('[data-sgf-go]');
        if (gg) { if (gg.hasAttribute('data-sgf-gift')) ctx.gift = true; go(gg.dataset.sgfGo); return; }
        var tee = t.closest('[data-sgf-tee]');
        if (tee && ctx.look) {
          var o = ctx.look, i = opts.indexOf(o), why = S['why' + bucket(o.cm)] || '';
          if (tee.dataset.sgfTee === '2') {
            if (opts[i + 1]) { o = opts[i + 1]; why = S.up || ''; }
            else why = why + ' ' + (S.up_none || '');
          }
          result(o, why); return;
        }
        if (t.closest('[data-sgf-show="chain"]')) {
          var len = ctx.len, top = opts[opts.length - 1].cm, bot = opts[0].cm;
          var lead = (S.why_m || '').replace('[n]', fmtLen(len));
          if (len > top + 3) { tooLong(lead); return; }
          var hit = nearestOpt(len);
          result(hit, lead + ' ' + (S['why' + bucket(hit.cm)] || '') + (len < bot - 3 ? ' ' + (S.short || '') : ''));
        }
      });
      if (backBtn) backBtn.addEventListener('click', function () { hist.pop(); var p = hist[hist.length - 1]; if (p) show(p); });

      var guideOpen = root.v2SgOnOpen;
      root.v2SgOnOpen = function (start) {
        if (typeof guideOpen === 'function') guideOpen();
        hist = []; ctx = {};
        if (!read()) { go('table'); return; }
        go(start === 'finder' ? 'who' : 'table');
      };

      // ---- the line under the lengths ----
      var line = null, picked = null;
      function choose(o, saved) {
        var l = document.querySelector('label[for="' + o.input.id + '"]');
        if (l) l.click(); else o.input.click();
        picked = { o: o, saved: saved };
        paintLine();
      }
      function paintLine() {
        if (!line) return;
        var on = picked && picked.o.input.checked;
        line.innerHTML = '';
        if (on) {
          line.className = 'v2-sgf-line is-set';
          var ck = document.createElement('span'); ck.className = 'v2-sgf-line__ck'; ck.setAttribute('aria-hidden', 'true'); ck.textContent = '✓';
          var tx = document.createElement('span'); tx.textContent = (S[picked.saved ? 'saved' : 'yours'] || '').replace('[size]', label(picked.o));
          var ch = document.createElement('button'); ch.type = 'button'; ch.setAttribute('data-sg-open', 'finder'); ch.textContent = S.change || '';
          line.appendChild(ck); line.appendChild(tx); line.appendChild(ch);
        } else {
          line.className = 'v2-sgf-line';
          var bt = document.createElement('button'); bt.type = 'button'; bt.setAttribute('data-sg-open', 'finder');
          bt.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="2.5" y="8" width="19" height="8" rx="1.5" fill="none" stroke="currentColor" stroke-width="1.5"/><path d="M6 8v3M9.5 8v4M13 8v3M16.5 8v4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';
          var q1 = document.createElement('span'); q1.textContent = S.cta_q || '';
          var a1 = document.createElement('b'); a1.textContent = S.cta_a || '';
          bt.appendChild(q1); bt.appendChild(a1); line.appendChild(bt);
        }
      }
      (function mount() {
        if (!read()) return;
        var fs = opts[0].input.closest('.product-form__controls');
        if (!fs || fs.classList.contains('d-single')) return;
        line = document.createElement('div');
        fs.parentNode.insertBefore(line, fs.nextSibling);
        fs.addEventListener('change', function () { setTimeout(paintLine, 0); });
        paintLine();
        function applyMem() {
          var mem = null;
          try { mem = JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) {}
          if (!mem || !mem.cm || !read()) return;
          if (opts.some(function (o) { return o.input.checked; })) return;
          var hit = opts.filter(function (o) { return o.cm === mem.cm; })[0];
          if (hit && !hit.input.disabled) choose(hit, true);
        }
        if (document.readyState === 'complete') setTimeout(applyMem, 600);
        else window.addEventListener('load', function () { setTimeout(applyMem, 600); });
      })();
    })();

    // 2026-10-13 (Johannes): earrings keep the ear photo guide but look and work
    // like the bracelet and chain finders: no tabs, a slim "Welke maat? Vind je
    // maat" line under the sizes, and "✓ Jouw maat: 5 mm · Wijzig" after a pick.
    (function () {
      var body = root.querySelector('[data-sg-ear-body]');
      if (!body) return;
      var S = {}, tpl = body.querySelector('[data-sgf-strings]');
      if (tpl && tpl.content) [].slice.call(tpl.content.querySelectorAll('[data-k]')).forEach(function (n) { S[n.dataset.k] = n.textContent; });
      var title = root.querySelector('.v2-sg__title');
      var earOpen = root.v2SgOnOpen;
      root.v2SgOnOpen = function (start) {
        if (typeof earOpen === 'function') earOpen();
        if (title) title.textContent = start === 'finder' ? body.dataset.tFinder : body.dataset.tTable;
      };
      var btn = document.querySelector('.product__info-container .product-form__controls .size-guide-btn');
      var fs = btn && btn.closest('.product-form__controls');
      if (!fs || fs.classList.contains('d-single') || fs.closest('.product__popup')) return;
      var line = document.createElement('div'), picked = null;
      fs.parentNode.insertBefore(line, fs.nextSibling);
      function paint() {
        line.innerHTML = '';
        if (picked && picked.input.checked) {
          line.className = 'v2-sgf-line is-set';
          var ck = document.createElement('span'); ck.className = 'v2-sgf-line__ck'; ck.setAttribute('aria-hidden', 'true'); ck.textContent = '✓';
          var tx = document.createElement('span'); tx.textContent = (S.yours || '').replace('[size]', picked.label);
          var ch = document.createElement('button'); ch.type = 'button'; ch.setAttribute('data-sg-open', 'finder'); ch.textContent = S.change || '';
          line.appendChild(ck); line.appendChild(tx); line.appendChild(ch);
        } else {
          line.className = 'v2-sgf-line';
          var bt = document.createElement('button'); bt.type = 'button'; bt.setAttribute('data-sg-open', 'finder');
          bt.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="2.5" y="8" width="19" height="8" rx="1.5" fill="none" stroke="currentColor" stroke-width="1.5"/><path d="M6 8v3M9.5 8v4M13 8v3M16.5 8v4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';
          var q1 = document.createElement('span'); q1.textContent = S.cta_q || '';
          var a1 = document.createElement('b'); a1.textContent = S.cta_a || '';
          bt.appendChild(q1); bt.appendChild(a1); line.appendChild(bt);
        }
      }
      var pick = root.querySelector('[data-sg-ear-pick]');
      if (pick) pick.addEventListener('click', function () {
        var on = root.querySelector('[data-sg-ear-pills] [aria-pressed="true"]');
        setTimeout(function () {
          var chk = fs.querySelector('input[type=radio]:checked');
          if (chk && on) picked = { input: chk, label: on.textContent };
          paint();
        }, 0);
      });
      fs.addEventListener('change', function () { setTimeout(paint, 0); });
      paint();
    })();

    // 2026-10-13 · ring finder (Johannes: same principle as bracelets and chains,
    // "the best way possible"). Measure a ring that fits (inside, edge to edge)
    // or a string round the finger, in mm. Circumference -> the table's size
    // (0.6 mm slack, same as the old calculator) -> this ring's size, or the next
    // one up. Above this ring's biggest size: contact. The table only lists this
    // ring's sizes. The measurement is remembered (not for gifts) and fills in a
    // size on the next ring only while nothing is picked yet.
    (function () {
      var box = root.querySelector('[data-sgfr]');
      if (!box) return;
      var KEY = 'drippy:sgf-rg';
      var S = {}, tpl = box.querySelector('[data-sgf-strings]');
      if (tpl && tpl.content) [].slice.call(tpl.content.querySelectorAll('[data-k]')).forEach(function (n) { S[n.dataset.k] = n.textContent; });
      var dec = box.dataset.dec || '.';
      var rows = [].slice.call(box.querySelectorAll('.v2-sg__table--ring tbody tr'));
      var title = root.querySelector('.v2-sg__title'), backBtn = root.querySelector('[data-sgf-back]');
      var hist = [], ctx = {}, opts = [];
      function num(x) { return parseFloat(String(x).replace(',', '.')); }
      function f1(x) { return (Math.round(x * 10) / 10).toFixed(1).replace('.', dec).replace(new RegExp('\\' + dec + '0$'), ''); }
      function read() {
        var all = [].slice.call(document.querySelectorAll('.product__info-container .product-parameters input[type=radio]'))
          .filter(function (i) { return !i.closest('.product__popup'); });
        opts = all.map(function (i) {
          var m = String(i.value).match(/^\s*(\d+(?:[.,]\d+)?)(?:\s*-\s*(\d+(?:[.,]\d+)?))?\s*$/);
          return m ? { input: i, lo: num(m[1]), hi: m[2] ? num(m[2]) : num(m[1]), name: String(i.value).trim() } : null;
        }).filter(Boolean).sort(function (a, b) { return a.lo - b.lo; });
        rows.forEach(function (r) {
          var sz = num(r.dataset.size);
          r.hidden = !opts.some(function (o) { return sz >= o.lo && sz <= o.hi; });
        });
        return opts.length > 0;
      }
      // circumference in mm -> { o, small } or null when it is above this ring's sizes
      function forCirc(c) {
        var row = rows.filter(function (r) { return num(r.dataset.circ) >= c - 0.6; })[0];
        if (!row) return null;
        var want = num(row.dataset.size);
        var exact = opts.filter(function (o) { return want >= o.lo && want <= o.hi; })[0];
        var up = opts.filter(function (o) { return o.lo > want; })[0];
        if (exact) return { o: exact, small: false, up: false };
        if (up) return { o: up, small: want < opts[0].lo, up: !(want < opts[0].lo) };
        return null;
      }
      function sizeLabel(o) { return (S.size || '[n]').replace('[n]', o.name); }

      var RANGE = { ring: [14, 24, 0.1, 18.2], finger: [44, 75, 0.1, 57] };
      function slider(kind) {
        var host = box.querySelector('[data-sgf-slider="' + kind + '"]');
        if (!host || host.dataset.built) return;
        host.dataset.built = '1';
        var R = RANGE[kind], lo = R[0], hi = R[1], W = 310 / (hi - lo), t = '', lab = '', every = kind === 'ring' ? 2 : 5;
        for (var v = lo; v <= hi + 1e-9; v++) {
          var x = 10 + (v - lo) * W, big = v % every === 0;
          t += '<path d="M' + x.toFixed(1) + ' 60v' + (big ? 12 : 6) + '" stroke="currentColor" stroke-width="' + (big ? 1.2 : 1) + '"/>';
          if (big) lab += '<text x="' + x.toFixed(1) + '" y="86" font-size="10" text-anchor="middle" fill="currentColor">' + v + '</text>';
        }
        var bar = kind === 'ring'
          ? '<rect data-bar x="10" y="34" width="0" height="7" rx="3.5" fill="#C9A24A"/>'
          : '<rect data-bar x="10" y="31" width="0" height="13" rx="2" fill="#F1E4C4" stroke="#B79C5E" stroke-width="1.2"/>';
        host.className = 'v2-sgf__sl';
        host.innerHTML = '<p class="v2-sgf__val"><output data-out></output></p>' +
          '<svg class="v2-sgf__ruler" viewBox="0 0 330 96" width="330" height="96" aria-hidden="true"><rect x="2" y="54" width="326" height="40" rx="4" fill="#fff" stroke="currentColor" stroke-width="1.3"/>' + t + lab + bar +
          '<path data-mark d="M10 26v24" stroke="#C0392B" stroke-width="2.4" stroke-linecap="round"/></svg>' +
          '<input type="range" class="v2-sgf__range" min="' + lo + '" max="' + hi + '" step="' + R[2] + '" value="' + R[3] + '" aria-label="' + (S.slider || '') + '" data-sg-noswipe>' +
          '<p class="v2-sgf__ends"><span>' + lo + ' mm</span><span>' + hi + ' mm</span></p>';
        var inp = host.querySelector('input'), out = host.querySelector('[data-out]'), b = host.querySelector('[data-bar]'), mk = host.querySelector('[data-mark]');
        function upd() {
          var v = num(inp.value), w = (v - lo) * W;
          ctx[kind] = v;
          out.textContent = f1(v) + ' mm';
          inp.setAttribute('aria-valuetext', out.textContent);
          b.setAttribute('width', w.toFixed(1)); mk.setAttribute('d', 'M' + (10 + w).toFixed(1) + ' 26v24');
          inp.style.setProperty('--p', ((v - lo) / (hi - lo) * 100) + '%');
          live(kind);
        }
        inp.addEventListener('input', upd); upd();
      }
      /* 2026-10-14 (Johannes): sizes live under the ruler, the button picks and closes */
      function live(kind) {
        var host = box.querySelector('[data-sgf-slider="' + kind + '"]'); if (!host) return;
        var fit = host.querySelector('[data-live-fit]'), note = host.querySelector('[data-live-note]');
        if (!fit) { fit = document.createElement('div'); fit.className = 'v2-sgf__fit v2-sgf__fit--live'; fit.setAttribute('data-live-fit', ''); host.appendChild(fit); note = document.createElement('p'); note.className = 'v2-sgf__hint'; note.setAttribute('data-live-note', ''); host.appendChild(note); }
        var v = ctx[kind], hit = forCirc(kind === 'ring' ? v * Math.PI : v);
        fit.innerHTML = '';
        opts.forEach(function (o) { var d = document.createElement('span'); d.textContent = o.name; if (hit && o === hit.o) d.className = 'is-me'; fit.appendChild(d); });
        note.textContent = hit ? ((hit.up ? (S.up || '') : '') + (hit.small ? ' ' + (S.small || '') : '')).trim() : '';
        note.hidden = !note.textContent;
        var btn = box.querySelector('[data-sgf-show="' + kind + '"]');
        if (btn) { if (!btn.dataset.orig) btn.dataset.orig = btn.textContent; btn.textContent = hit ? (S.pick || 'Pick [size]').replace('[size]', sizeLabel(hit.o)) : btn.dataset.orig; }
      }

      function show(step) {
        [].slice.call(box.querySelectorAll('[data-sgf-step]')).forEach(function (s) { s.hidden = s.dataset.sgfStep !== step; });
        if (title) title.textContent = step === 'table' ? box.dataset.tTable : box.dataset.tFinder;
        if (backBtn) backBtn.hidden = hist.length < 2;
        if (step === 'ring' || step === 'finger') slider(step);
        [].slice.call(box.querySelectorAll('[data-sgf-me]')).forEach(function (n) { n.hidden = !!ctx.gift; });
        [].slice.call(box.querySelectorAll('[data-sgf-gifted]')).forEach(function (n) { n.hidden = !ctx.gift; });
        box.scrollTop = 0;
      }
      function go(step) { hist.push(step); show(step); }
      function result(hit, why, est, circ) {
        hist.push('result');
        box.querySelector('[data-sgf-lbl]').textContent = S[ctx.gift ? 'gift' : 'me'] || '';
        box.querySelector('[data-sgf-big]').textContent = hit.o.name;
        box.querySelector('[data-sgf-why-out]').textContent = why + (est ? ' ' + (S.est || '') : '') + (hit.up ? ' ' + (S.up || '') : '') + (hit.small ? ' ' + (S.small || '') : '');
        var fit = box.querySelector('[data-sgf-fit]'); fit.innerHTML = '';
        opts.forEach(function (o) { var d = document.createElement('span'); d.textContent = o.name; if (o === hit.o) d.className = 'is-me'; fit.appendChild(d); });
        var pick = box.querySelector('[data-sgf-pick]');
        pick.textContent = (S.pick || 'Pick [size]').replace('[size]', sizeLabel(hit.o));
        pick.onclick = function () {
          choose(hit.o, false);
          if (!ctx.gift && !est) { try { localStorage.setItem(KEY, JSON.stringify({ circ: circ })); localStorage.setItem('drippy:pick-ring', hit.o.name); } catch (e) {} }
          close();
        };
        show('result');
      }
      function tooBig(why) {
        hist.push('big');
        box.querySelector('[data-sgf-big-out]').textContent = why + ' ' + (S.big_b || '').replace('[size]', opts[opts.length - 1].name);
        show('big');
      }
      box.addEventListener('click', function (e) {
        var t = e.target, gg = t.closest('[data-sgf-go]');
        if (gg) { if (gg.hasAttribute('data-sgf-gift')) ctx.gift = true; go(gg.dataset.sgfGo); return; }
        var q = t.closest('[data-sgf-guess]');
        if (q) { var c0 = num(q.dataset.sgfGuess), h0 = forCirc(c0); if (h0) result(h0, '', true, c0); else tooBig(''); return; }
        var s = t.closest('[data-sgf-show]');
        if (s) {
          var kind = s.dataset.sgfShow, v = ctx[kind];
          var circ = kind === 'ring' ? v * Math.PI : v;
          var why = (S[kind === 'ring' ? 'why_r' : 'why_f'] || '').replace('[n]', f1(v) + ' mm');
          var hit = forCirc(circ);
          if (!hit) { tooBig(why); return; }
          choose(hit.o, false);
          if (!ctx.gift) { try { localStorage.setItem(KEY, JSON.stringify({ circ: circ })); localStorage.setItem('drippy:pick-ring', hit.o.name); } catch (e) {} }
          close();
        }
      });
      if (backBtn) backBtn.addEventListener('click', function () { hist.pop(); var p = hist[hist.length - 1]; if (p) show(p); });
      root.v2SgOnOpen = function (start) {
        hist = []; ctx = {};
        if (!read()) { go('table'); return; }
        go(start === 'finder' ? 'who' : 'table');
      };

      var line = null, picked = null;
      function choose(o, saved) {
        var l = document.querySelector('label[for="' + o.input.id + '"]');
        if (l) l.click(); else o.input.click();
        picked = { o: o, saved: saved };
        paintLine();
      }
      function paintLine() {
        if (!line) return;
        line.innerHTML = '';
        if (picked && picked.o.input.checked) {
          line.className = 'v2-sgf-line is-set';
          var ck = document.createElement('span'); ck.className = 'v2-sgf-line__ck'; ck.setAttribute('aria-hidden', 'true'); ck.textContent = '✓';
          var tx = document.createElement('span'); tx.textContent = (S[picked.saved ? 'saved' : 'yours'] || '').replace('[size]', picked.o.name);
          var ch = document.createElement('button'); ch.type = 'button'; ch.setAttribute('data-sg-open', 'finder'); ch.textContent = S.change || '';
          line.appendChild(ck); line.appendChild(tx); line.appendChild(ch);
        } else {
          line.className = 'v2-sgf-line';
          var bt = document.createElement('button'); bt.type = 'button'; bt.setAttribute('data-sg-open', 'finder');
          bt.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="2.5" y="8" width="19" height="8" rx="1.5" fill="none" stroke="currentColor" stroke-width="1.5"/><path d="M6 8v3M9.5 8v4M13 8v3M16.5 8v4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';
          var q1 = document.createElement('span'); q1.textContent = S.cta_q || '';
          var a1 = document.createElement('b'); a1.textContent = S.cta_a || '';
          bt.appendChild(q1); bt.appendChild(a1); line.appendChild(bt);
        }
      }
      (function mount() {
        if (!read()) return;
        var fs = opts[0].input.closest('.product-form__controls');
        if (!fs || fs.classList.contains('d-single')) return;
        line = document.createElement('div');
        fs.parentNode.insertBefore(line, fs.nextSibling);
        fs.addEventListener('change', function () { setTimeout(paintLine, 0); });
        paintLine();
        function applyMem() {
          var mem = null;
          try { mem = JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) {}
          if (!mem || !mem.circ || !read()) return;
          if (opts.some(function (o) { return o.input.checked; })) return;
          var hit = forCirc(mem.circ);
          if (hit && !hit.up && !hit.small && !hit.o.input.disabled) choose(hit.o, true);
        }
        if (document.readyState === 'complete') setTimeout(applyMem, 600);
        else window.addEventListener('load', function () { setTimeout(applyMem, 600); });
      })();
    })();

    document.addEventListener('click', function (e) {
      var t = e.target;
      var info = document.querySelector('.product__info-container');
      if (!info) return;
      // The theme's SIZE GUIDE button, plus our own trigger on pendant pages,
      // which have no size option and therefore no theme button.
      var hit = t.closest ? t.closest('.size-guide-btn, [data-sg-open]') : null;
      if (hit && info.contains(hit)) {
        e.preventDefault();
        e.stopPropagation();
        // 2026-10-18 (Jo): the Size guide link opens the size finder itself (one place for one job); the chart sits behind a link in it.
        open(hit.getAttribute('data-sg-open') || 'finder');
      }
    }, true);

    root.addEventListener('click', function (e) {
      var t = e.target;

      if (t.closest('[data-sg-close]')) {
        close();
        return;
      }

      var tab = t.closest('[data-sg-tab]');
      if (tab) {
        var name = tab.dataset.sgTab;
        var tabs = root.querySelectorAll('[data-sg-tab]');
        for (var i = 0; i < tabs.length; i++) {
          tabs[i].setAttribute('aria-selected', String(tabs[i] === tab));
        }
        var panels = root.querySelectorAll('[data-sg-panel]');
        for (var j = 0; j < panels.length; j++) {
          panels[j].hidden = panels[j].dataset.sgPanel !== name;
          if (panels[j].hidden) pauseVideos(panels[j]); else wakeVideos(panels[j]);
        }
        root.querySelector('.v2-sg__body').scrollTop = 0;
        return;
      }

      var seg = t.closest('[data-sg-seg]');
      if (seg) {
        var which = seg.dataset.sgSeg;
        var segs = root.querySelectorAll('[data-sg-seg]');
        for (var k = 0; k < segs.length; k++) {
          segs[k].setAttribute('aria-pressed', String(segs[k] === seg));
        }
        var imgs = root.querySelectorAll('[data-sg-segpanel]');
        for (var l = 0; l < imgs.length; l++) {
          imgs[l].hidden = imgs[l].dataset.sgSegpanel !== which;
        }
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !root.hidden) close();
    });
  }

  /* ---- Accordions ----
     The three info blocks are modal openers in the theme: a link that opens a
     dialog, with the content already sitting in the page under a .no-js class.
     Reusing that content in place turns them into inline accordions without
     forking the section. The theme's <style> forces
     `.button--simple { font-size: 1rem !important }`, so the class is dropped
     from the button rather than fought with specificity. */
  /* The in-page copy the theme leaves under .no-js carries only the first text
     field; the dialog carries the rest (returns, care). The dialog is moved to
     <body> by its own custom element, so it has to be found by id from the
     opener rather than looked up inside the block. */
  function fillBodies() {
    var pops = document.querySelectorAll('.product__info-main_content > .product-popup');
    for (var i = 0; i < pops.length; i++) {
      var pop = pops[i];
      var body = pop.querySelector('.product-popup-modal__content-info');
      var opener = pop.querySelector('modal-opener[data-modal]');
      if (!body || !opener || body.dataset.v2Full) continue;
      var dialog = document.querySelector(opener.getAttribute('data-modal'));
      var full = dialog ? dialog.querySelector('.product-popup-modal__content-info') : null;
      if (!full) continue;
      if (full.innerHTML.trim().length > body.innerHTML.trim().length) {
        body.innerHTML = full.innerHTML;
        body.dataset.v2Full = '1';
        delete body.dataset.v2Enriched;
      }
    }
  }

  function accordions() {
    var pops = document.querySelectorAll('.product__info-main_content > .product-popup');
    if (!pops.length) return;

    for (var i = 0; i < pops.length; i++) {
      var pop = pops[i];
      if (pop.dataset.v2Acc) continue;
      var btn = pop.querySelector('button');
      var body = pop.querySelector('.product-popup-modal__content-info');
      if (!btn || !body) continue;

      pop.classList.add('v2-acc');
      btn.classList.remove('button--simple');
      btn.classList.add('v2-acc__summary');
      btn.setAttribute('aria-expanded', 'false');
      btn.removeAttribute('aria-haspopup');
      body.classList.add('v2-acc__body');

      var chev = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      chev.setAttribute('class', 'v2-acc__chev');
      chev.setAttribute('viewBox', '0 0 20 20');
      chev.setAttribute('aria-hidden', 'true');
      var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      path.setAttribute('d', 'M5 7.5 10 12.5 15 7.5');
      path.setAttribute('fill', 'none');
      path.setAttribute('stroke', 'currentColor');
      path.setAttribute('stroke-width', '1.6');
      path.setAttribute('stroke-linecap', 'round');
      path.setAttribute('stroke-linejoin', 'round');
      chev.appendChild(path);
      btn.appendChild(chev);

      pop.dataset.v2Acc = '1';
    }

    document.addEventListener('click', function (e) {
      var hit = e.target.closest ? e.target.closest('.v2-acc__summary') : null;
      if (!hit) return;
      e.preventDefault();
      e.stopPropagation();
      var pop = hit.closest('.v2-acc');
      var open = !pop.classList.contains('is-open');

      /* One at a time: opening one closes the others. */
      var all = document.querySelectorAll('.v2-acc');
      for (var i = 0; i < all.length; i++) {
        if (all[i] === pop) continue;
        all[i].classList.remove('is-open');
        var sum = all[i].querySelector('.v2-acc__summary');
        if (sum) sum.setAttribute('aria-expanded', 'false');
      }

      pop.classList.toggle('is-open', open);
      hit.setAttribute('aria-expanded', String(open));
    }, true);
  }

  /* Folds the Liquid-rendered blocks from pdp-v2-data into the theme's own
     accordions, and appends this product's own FAQ entry if it has one. */
  /* premium_description restates the spec table in bullet form, in different
     words, and contradicts it — "high-clarity stones" where the table says 5A
     cubic zirconia. Two sources of truth in one accordion.

     This used to cut from the first bold-led paragraph onward and keep the
     opening prose, but the cut was unreliable across products and the prose it
     kept ("Balanced ice. Strong presence.") said nothing anyway. The whole
     metafield is dropped and the table is the only thing under this label. */
  function trimToDescription(body) {
    if (body.dataset.v2Trimmed) return;
    var host = body.querySelector('.metafield-rich_text_field');
    if (host) {
      host.remove();
    } else {
      var wrap = body.querySelector('.product-popup-modal__text');
      if (wrap) wrap.remove();
    }
    body.dataset.v2Trimmed = '1';
  }

  function enrich() {
    var specs = real('#v2-specs');
    var ship = real('#v2-shipping');
    var warr = real('#v2-warranty');
    var accs = document.querySelectorAll('.v2-acc');

    for (var i = 0; i < accs.length; i++) {
      var label = accs[i].querySelector('.v2-acc__summary span');
      var body = accs[i].querySelector('.v2-acc__body');
      if (!label || !body || body.dataset.v2Enriched) continue;
      var name = label.textContent.toLowerCase();
      /* Matched by block id first (labels are translated), name as fallback. */
      var bid = (accs[i].querySelector('.v2-acc__summary') || {}).id || '';
      var tpl = null;
      if (specs && (bid.indexOf('popup_6wK9c3') > -1 || name.indexOf('material') > -1)) {
        tpl = specs;
        trimToDescription(body);
      }
      if (ship && (bid.indexOf('popup_yX9T7z') > -1 || name.indexOf('shipping') > -1)) tpl = ship;
      if (warr && bid.indexOf('popup_VxyCJQ') > -1) tpl = warr;
      if (!tpl) continue;
      /* Shipping and warranty are rebuilt whole from the templates (2026-10-01):
         the popup's own setting text is dropped so nothing is said twice. */
      if (tpl === ship || tpl === warr) {
        var old = body.querySelectorAll('.product-popup-modal__text, .product-popup-modal__text_3, .product-popup-modal__title');
        for (var o = 0; o < old.length; o++) old[o].remove();
      }
      body.classList.add('v2-acc__body--rich');
      body.appendChild(tpl.content.cloneNode(true));
      body.dataset.v2Enriched = '1';
    }

    var extra = real('#v2-faq-extra');
    var list = document.querySelector('.v2-faq__list');

    /* Several products carry "Will it fade?", which the standard "Will it fade
       or turn green?" already answers. Only append a question the page is not
       asking already. */
    if (extra && list && !list.dataset.v2Extra) {
      var norm = function (t) { return (t || '').toLowerCase().replace(/[^a-z ]/g, '').trim(); };
      var q = norm(extra.dataset.q);
      var existing = list.querySelectorAll('.v2-faq__q');
      var dupe = false;
      for (var k = 0; k < existing.length; k++) {
        var e = norm(existing[k].textContent);
        if (e.indexOf(q) === 0 || q.indexOf(e) === 0) dupe = true;
      }
      if (dupe) {
        list.dataset.v2Extra = '1';
        return;
      }
    }

    if (extra && list && !list.dataset.v2Extra) {
      var d = document.createElement('details');
      d.className = 'v2-faq__item';
      var sum = document.createElement('summary');
      sum.className = 'v2-faq__q';
      sum.textContent = extra.dataset.q;
      var ans = document.createElement('div');
      ans.className = 'v2-faq__a';
      var para = document.createElement('p');
      para.textContent = extra.dataset.a;
      ans.appendChild(para);
      d.appendChild(sum);
      d.appendChild(ans);
      list.appendChild(d);
      list.dataset.v2Extra = '1';
    }
  }

  /* Complete the set and Related pieces render the theme's product cards, which
     carry a "Ships tomorrow" line. The finish is the more useful thing to scan
     here — same treatment as the collection grid. */
  var FINISH_SUFFIXES = [
    ['-925-white-gold', 'White gold finish'],
    ['-925-18k-gold', '18K gold finish'],
    ['-white-gold', 'White gold finish'],
    ['-18k-gold', '18K gold finish'],
    ['-14k-gold', '14K gold finish']
  ];

  function finishForCard(card) {
    var link = card.querySelector('a[href*="/products/"]');
    if (link) {
      var handle = (link.getAttribute('href').split('/products/')[1] || '').split('?')[0].split('#')[0];
      for (var i = 0; i < FINISH_SUFFIXES.length; i++) {
        var suf = FINISH_SUFFIXES[i][0];
        if (handle.length > suf.length && handle.slice(-suf.length) === suf) return FINISH_SUFFIXES[i][1];
      }
    }
    var t = (card.textContent || '').toUpperCase();
    if (t.indexOf('WHITE GOLD') > -1) return 'White gold finish';
    if (t.indexOf('14K') > -1) return '14K gold finish';
    if (t.indexOf('GOLD') > -1) return '18K gold finish';
    if (t.indexOf('925') > -1) return '925 sterling silver';
    return null;
  }

  function labelCardFinishes() {
    var slots = document.querySelectorAll('.cro-card-ships');
    for (var i = 0; i < slots.length; i++) {
      var slot = slots[i];
      if (slot.dataset.v2Finish) continue;
      // 2026-10-13: product-card.liquid already prints the finish, translated
      // (.cro-card-spec). Overwriting it put English on every language's PDP.
      if (slot.classList.contains('cro-card-spec')) continue;
      var card = slot.closest('.card-wrapper, .collection-product-card, li, .card');
      if (!card) continue;
      var finish = finishForCard(card);
      if (!finish) continue;
      slot.textContent = finish;
      slot.classList.add('v2-card-finish');
      slot.dataset.v2Finish = '1';
    }
  }

  /* ---- Sticky add to cart ----
     The theme renders the bar and styles `.product__popup.active` to slide it
     up, but nothing anywhere in the theme ever adds that class — so the sticky
     cart has never actually appeared, on any breakpoint.
     Driven off scroll rather than IntersectionObserver: the page renders two
     copies of the buy button and the hidden 0x0 one never intersects, which
     left the observer silent. */
  function stickyBar() {
    var bar = document.querySelector('.product__popup');
    if (!bar) return;

    function anchor() {
      var all = document.querySelectorAll('.product__info-container .product__buy_buttons');
      for (var i = 0; i < all.length; i++) {
        if (all[i].getBoundingClientRect().height > 0) return all[i];
      }
      return null;
    }

    /* The theme's own `.product__popup.active { transform: translateY(0) }`
       does not win in practice — section-main-product.css is served twice and
       the base translateY(100%) keeps applying — so the offset is set straight
       on the element instead of fighting the cascade. */
    bar.style.transition = 'transform 0.35s cubic-bezier(0.22, 1, 0.36, 1), opacity 0.2s ease, visibility 0s linear 0.35s';
    bar.style.visibility = 'hidden'; bar.style.opacity = '0';

    var ticking = false;
    var shown = null;
    function check() {
      ticking = false;
      var a = anchor();
      if (!a) return;
      // 2026-10-10 (Johannes): pop up once the buy button is gone AND the
      // Drippy standard is on screen; fully invisible otherwise, because on
      // iPhones a bar parked just below the edge peeked in when Safari's
      // toolbar collapsed, so it looked visible straight away.
      var std = document.querySelector('.dstd');
      var past = a.getBoundingClientRect().bottom < 0 && (!std || std.getBoundingClientRect().top < window.innerHeight);
      if (past === shown) return;
      shown = past;
      // visible at once when it comes in; hidden only after it has slid out
      bar.style.transition = 'transform 0.35s cubic-bezier(0.22, 1, 0.36, 1), opacity 0.2s ease, visibility 0s linear ' + (past ? '0s' : '0.35s');
      bar.classList.toggle('active', past);
      bar.style.transform = past ? 'translateY(0)' : 'translateY(110%)';
      bar.style.visibility = past ? 'visible' : 'hidden';
      bar.style.opacity = past ? '1' : '0';
      bar.style.pointerEvents = past ? '' : 'none';
    }

    /* setTimeout, not requestAnimationFrame: rAF is paused in background or
       hidden tabs, which left the bar stuck until the next visible frame. */
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      setTimeout(check, 60);
    }, { passive: true });

    window.addEventListener('resize', check);
    check();
  }

  /* The sticky bar carries the theme's own copy of the variant picker, which
     paint() never touches — it reformats the picker in the buy column. Its
     labels read "6 inch / 15 cm", which is three times wider than a bar chip
     needs. Same shortening, applied where it lives. */
  function shortenBarSizes() {
    var labels = document.querySelectorAll('.product__popup .product-form__controls-group label');
    for (var i = 0; i < labels.length; i++) {
      var label = labels[i];
      if (label.dataset.v2Bar) continue;
      var node = firstTextNode(label);
      if (!node) continue;
      var m = node.textContent.match(SIZE_RE);
      if (m) node.textContent = sizeParts(m).big;
      label.dataset.v2Bar = '1';
    }
  }

  /* On arrival the theme checks the first variant, which for 16 of 29
     bracelets is 6 inch and for 19 of 31 chains is 16 inch — the two sizes
     with the highest refund rate, and the ones a man reads as not for him.
     When the URL names no variant, start on the size this product's own
     buyers order most (pdp-v2-popular-size), so the price, the media and the
     "Most popular" pill are right on first paint instead of after a click. */
  function defaultToPopular() {
    if (/[?&]variant=/.test(window.location.search)) return;
    var src = real('.v2-popular-src');
    var popular = src && src.dataset.v2Popular;
    if (!popular) return;
    var radios = document.querySelectorAll('.product__info-container input[type="radio"]');
    for (var i = 0; i < radios.length; i++) {
      var r = radios[i];
      if (normalizeSize(r.value) !== normalizeSize(popular)) continue;
      if (r.checked || r.disabled || r.classList.contains('disabled')) return;
      r.click();
      return;
    }
  }

  /* #drippyfam fits on a phone: open the strip on the second photo, centred,
     so the first peeks in from the left and the third from the right and the
     row reads as full from edge to edge instead of starting with a margin.
     Desktop shows the whole row and is left alone. */
  function centerFamStrip() {
    if (window.innerWidth >= 750) return;
    var strip = document.querySelector('.v2-fam__strip');
    var items = strip && strip.querySelectorAll('.v2-fam__item');
    if (!items || items.length < 3) return;
    /* Snap points are set here as well as in drippy-fam.css, so a cached
       stylesheet cannot leave the strip snapping back to the margin. */
    for (var i = 0; i < items.length; i++) items[i].style.scrollSnapAlign = 'center';
    var second = items[1];
    strip.scrollLeft = second.offsetLeft - (strip.clientWidth - second.offsetWidth) / 2;
  }

  /* FAQ: one question open at a time, like the info accordions above it.
     The extra per-product question is appended to the same list later, so
     this listens on the list (toggle does not bubble; capture catches it). */
  function faqOneAtATime() {
    var list = document.querySelector('.v2-faq__list');
    if (!list || list.dataset.v2One) return;
    list.dataset.v2One = '1';
    list.addEventListener('toggle', function (e) {
      var d = e.target;
      if (!d || !d.open || !d.classList || !d.classList.contains('v2-faq__item')) return;
      var all = list.querySelectorAll('details.v2-faq__item[open]');
      for (var i = 0; i < all.length; i++) if (all[i] !== d) all[i].open = false;
    }, true);
  }

  function start() {
    defaultToPopular();
    centerFamStrip();
    paint();
    sizeGuide();
    accordions();
    faqOneAtATime();
    fillBodies();
    enrich();

    /* The dialogs are relocated asynchronously by their custom element, so
       take a second pass once that has settled. */
    setTimeout(function () {
      fillBodies();
      enrich();
    }, 700);
    labelCardFinishes();
    stickyBar();
    shortenBarSizes();
    setTimeout(shortenBarSizes, 700);

    /* Recommendation cards and related products arrive after their own fetch. */
    var main = document.querySelector('main');
    if (main && window.MutationObserver) {
      var t = null;
      new MutationObserver(function () {
        clearTimeout(t);
        t = setTimeout(labelCardFinishes, 150);
      }).observe(main, { childList: true, subtree: true });
    }
    document.addEventListener('change', function (e) {
      if (e.target && e.target.type === 'radio') paint();
    });

    // The theme re-renders the picker for combined listings and high-variant
    // products, so re-apply whenever the options are replaced.
    var target = document.querySelector('.product__info-container .product-parameters');
    if (target && window.MutationObserver) {
      new MutationObserver(paint).observe(target, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* build 1789753785 */

/* Desktop gallery thumbnails (2026-10-01). The thumbnail column is the theme's
   horizontal thumb strip restyled as a vertical column, and a page script stops
   click bubbling, so the Swiper thumbs link never fires. Drive the main slider
   directly, in the capture phase, and mark the active thumbnail. */
(function () {
  if (window.__drippyThumbCol) return;
  window.__drippyThumbCol = true;
  function sync(wrapper) {
    var main = wrapper.querySelector('.product__media-list');
    var thumbs = wrapper.querySelectorAll('.product__media-sublist .swiper-slide');
    if (!main || !main.swiper) return;
    var i = main.swiper.activeIndex;
    for (var k = 0; k < thumbs.length; k++) thumbs[k].classList.toggle('swiper-slide-thumb-active', k === i);
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('.main-product-desktop-section-wrapper .product__media-sublist .swiper-slide');
    if (!t) return;
    var wrapper = t.closest('.main-product-desktop-section-wrapper');
    var main = wrapper && wrapper.querySelector('.product__media-list');
    if (!main || !main.swiper) return;
    var idx = Array.prototype.indexOf.call(t.parentElement.children, t);
    main.swiper.slideTo(idx);
    setTimeout(function () { sync(wrapper); }, 50);
  }, true);
  function bind() {
    document.querySelectorAll('.main-product-desktop-section-wrapper').forEach(function (w) {
      var main = w.querySelector('.product__media-list');
      if (main && main.swiper && !main.__thumbSync) {
        main.__thumbSync = true;
        main.swiper.on('slideChange', function () { sync(w); });
        sync(w);
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(bind, 300); });
  else setTimeout(bind, 300);
  window.addEventListener('load', function () { setTimeout(bind, 300); });
})();

/* Desktop full-bleed gallery counter "1 / 3" (2026-10-01). */
(function () {
  function mount() {
    var list = document.querySelector('.main-product-desktop-section-wrapper .product__media-list');
    if (!list || !list.swiper || list.querySelector('.v2-gal-count')) return;
    var el = document.createElement('div');
    el.className = 'v2-gal-count';
    el.setAttribute('aria-hidden', 'true');
    list.appendChild(el);
    var sw = list.swiper;
    var total = sw.slides.length;
    function upd() { el.textContent = (sw.activeIndex + 1) + ' / ' + total; }
    sw.on('slideChange', upd);
    upd();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(mount, 400); });
  else setTimeout(mount, 400);
  window.addEventListener('load', function () { setTimeout(mount, 400); });
})();

/* Desktop full-bleed gallery: flip header logo/menu and chevrons to white
   when the photo under them is dark (2026-10-01). Samples the active image
   on a tiny canvas; Shopify's CDN serves images with CORS. */
(function () {
  var cache = {};
  function lum(img, cb) {
    var src = img.currentSrc || img.src;
    if (!src) return cb(null);
    if (cache[src] != null) return cb(cache[src]);
    var probe = new Image();
    probe.crossOrigin = 'anonymous';
    probe.onload = function () {
      try {
        var c = document.createElement('canvas'); c.width = 24; c.height = 24;
        var x = c.getContext('2d'); x.drawImage(probe, 0, 0, 24, 24);
        var d = x.getImageData(0, 0, 24, 24).data, s = 0;
        for (var i = 0; i < d.length; i += 4) s += 0.2126 * d[i] + 0.7152 * d[i + 1] + 0.0722 * d[i + 2];
        cache[src] = s / (d.length / 4); cb(cache[src]);
      } catch (e) { cb(null); }
    };
    probe.onerror = function () { cb(null); };
    probe.src = src.replace(/([?&])width=\d+/, '$1width=100');
  }
  function check(list) {
    if (!window.matchMedia('(min-width: 990px)').matches) { document.documentElement.classList.remove('v2-gal-dark'); return; }
    var slide = list.swiper && list.swiper.slides[list.swiper.activeIndex];
    var img = slide && slide.querySelector('img');
    if (!img) return;
    lum(img, function (L) { document.documentElement.classList.toggle('v2-gal-dark', L != null && L < 110); });
  }
  function bind() {
    var list = document.querySelector('.main-product-desktop-section-wrapper .product__media-list');
    if (!list || !list.swiper || list.__lumBound) return;
    list.__lumBound = true;
    list.swiper.on('slideChange', function () { check(list); });
    check(list);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(bind, 500); });
  else setTimeout(bind, 500);
  window.addEventListener('load', function () { setTimeout(bind, 500); });
})();

/* Mark dark photos so the desktop frame fills with them (cover) while light
   packshots stay contained on their matching #fafafa ground (2026-10-01). */
(function () {
  function markAll() {
    var list = document.querySelector('.main-product-desktop-section-wrapper .product__media-list');
    if (!list) return;
    list.querySelectorAll('.product__media-item').forEach(function (slide) {
      var img = slide.querySelector('img');
      if (!img || slide.__lumDone) return;
      slide.__lumDone = true;
      var src = (img.currentSrc || img.src || '').replace(/([?&])width=\d+/, '$1width=100');
      if (!src) return;
      var p = new Image(); p.crossOrigin = 'anonymous';
      p.onload = function () {
        try {
          var c = document.createElement('canvas'); c.width = 24; c.height = 24;
          var x = c.getContext('2d'); x.drawImage(p, 0, 0, 24, 24);
          var d = x.getImageData(0, 0, 24, 24).data, s = 0;
          for (var i = 0; i < d.length; i += 4) s += 0.2126 * d[i] + 0.7152 * d[i + 1] + 0.0722 * d[i + 2];
          if (s / (d.length / 4) < 110) slide.classList.add('v2-slide-dark');
        } catch (e) {}
      };
      p.src = src;
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(markAll, 500); });
  else setTimeout(markAll, 500);
  window.addEventListener('load', function () { setTimeout(markAll, 500); });
})();

/* Rating line under the gallery (Johannes 2026-10-01): Loox prints
   "4.9 - Read 700 reviews"; shown as "4.9 · 700 reviews" in the shopper's
   language. Loox renders late, so the label is rewritten whenever it changes. */
(function () {
  function fix(el) {
    var t = (el.textContent || '').trim();
    var nums = t.match(/\d+(?:[.,]\d+)?/g);
    if (!nums || nums.length < 2 || el.dataset.v2Fixed === t) return;
    // 2026-10-13 (Johannes): "Read 47 reviews" with a light underline, so it reads as clickable
    var T = window.PDP_V2_T || {};
    var read = (T.read || ('Read %n ' + (T.reviews || 'reviews'))).replace('%n', nums[nums.length - 1]);
    var sp = document.createElement('span'); sp.className = 'd-read'; sp.textContent = read;
    var r = Number(nums[0].replace(',', '.')), lg = document.documentElement.lang || 'en';
    el.textContent = (isNaN(r) ? nums[0] : r.toLocaleString(lg, { minimumFractionDigits: 1, maximumFractionDigits: 1 })) + ' · '; el.appendChild(sp);
    el.dataset.v2Fixed = el.textContent;
  }
  function run() {
    document.querySelectorAll('.product__info-container .loox-rating-label').forEach(fix);
  }
  function start() {
    run();
    var host = document.querySelector('.product__info-container');
    if (host && window.MutationObserver) new MutationObserver(run).observe(host, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* Sticky bar adds the size picked in the buy column (QA B1, 2026-10-09).
   The bar is a clone of the buy column fetched from the product URL, so its
   own <form> holds the product's default variant and never hears about the
   size the shopper picked above. Keep the bar's variant id equal to the main
   form's id at all times, and copy it again at the moment the bar submits.
   A size picked inside the bar is mirrored back into the main picker, so the
   two never disagree. */
(function () {
  function inBar(el) { return !!(el && el.closest && el.closest('.product__popup')); }
  function visible(el) { return !!(el && el.getClientRects && el.getClientRects().length); }
  function mainForm() {
    var forms = document.querySelectorAll('form[id^="product-form-"]');
    var first = null;
    for (var i = 0; i < forms.length; i++) {
      var f = forms[i];
      if (inBar(f) || /installment/.test(f.id) || !f.querySelector('input[name="id"]')) continue;
      if (!first) first = f;
      if (visible(f)) return f;
    }
    return first;
  }
  function mainPicker() {
    var all = document.querySelectorAll('variant-radios, variant-selects');
    var first = null;
    for (var i = 0; i < all.length; i++) {
      if (inBar(all[i])) continue;
      if (!first) first = all[i];
      if (visible(all[i])) return all[i];
    }
    return first;
  }
  function push() {
    var f = mainForm();
    var id = f && f.querySelector('input[name="id"]');
    if (!id || !id.value) return;
    var bar = document.querySelectorAll('.product__popup form input[name="id"]');
    for (var i = 0; i < bar.length; i++) if (bar[i].value !== id.value) bar[i].value = id.value;
  }
  /* A radio picked in the bar: click the same value in the same option group
     of the main picker; the theme then updates the main form and push() runs. */
  function mirror(radio) {
    var barPicker = radio.closest('variant-radios, variant-selects');
    var main = mainPicker();
    if (!barPicker || !main) return;
    var groups = barPicker.querySelectorAll('fieldset, .product-form__controls');
    var mainGroups = main.querySelectorAll('fieldset, .product-form__controls');
    var g = radio.closest('fieldset, .product-form__controls');
    var idx = Array.prototype.indexOf.call(groups, g);
    var target = mainGroups[idx] || main;
    var inputs = target.querySelectorAll('input[type="radio"]');
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].value === radio.value) { if (!inputs[i].checked) inputs[i].click(); return; }
    }
  }
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t) return;
    if (inBar(t)) { if (t.type === 'radio') mirror(t); }
    else if (t.name === 'id') push();
  }, true);
  document.addEventListener('variant:change', function () { setTimeout(push, 0); });
  document.addEventListener('submit', function (e) { if (inBar(e.target)) push(); }, true);
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('.product__popup [name="add"], .product__popup button[type="submit"]');
    if (b) push();
  }, true);
  function start() {
    push();
    var bar = document.querySelector('.product__popup');
    if (bar && window.MutationObserver) {
      var t = null;
      new MutationObserver(function () { clearTimeout(t); t = setTimeout(push, 50); })
        .observe(bar, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  window.addEventListener('load', push);
})();

/* Rating line click scrolls to the Reviews section on the page instead of
   opening Loox's floating popup, which loads slowly (Johannes 2026-10-09).
   Capture phase so Loox's own click handler never sees the click. */
(function () {
  document.addEventListener('click', function (e) {
    var hit = e.target.closest && e.target.closest('.product__info-container .loox-rating');
    if (!hit) return;
    if (document.getElementById('d-rsheet-data')) return;   // 2026-10-11: the reviews sheet handles it, no scroll
    var target = document.querySelector('[id$="__v2_reviews_head"]') ||
                 document.getElementById('looxReviews') ||
                 document.querySelector('[id$="__v2_reviews_summary"]');
    if (!target) return;
    e.preventDefault();
    e.stopPropagation();
    var header = document.querySelector('.section-header, sticky-header, header');
    var offset = header ? header.getBoundingClientRect().height : 0;
    var y = target.getBoundingClientRect().top + window.pageYOffset - offset - 12;
    window.scrollTo({ top: Math.max(y, 0), behavior: 'smooth' });
  }, true);
})();

/* Gallery swipe hint on phones (Johannes 2026-10-10): shortly after the page
   loads, the photo slider pulls about 8% to the left and springs back, so
   shoppers see there are more photos to swipe. Once per visit, only on the
   first photo, skipped if the shopper already touched the gallery or asks
   their device for reduced motion. */
(function () {
  if (!window.matchMedia('(max-width: 749px)').matches) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  try { if (sessionStorage.getItem('dGalNudge')) return; } catch (e) {}
  var touched = false, tries = 0;
  document.addEventListener('touchstart', function (e) {
    if (e.target.closest && e.target.closest('.js-media-mobile-list, .js-media-list')) touched = true;
  }, { passive: true, capture: true });
  function go() {
    var el = document.querySelector('.js-media-mobile-list.swiper-initialized') ||
             document.querySelector('.js-media-list.swiper-initialized');
    var s = el && el.swiper;
    if (!s) { if (++tries < 20) setTimeout(go, 250); return; }
    if (touched || s.destroyed || s.slides.length < 2 || s.activeIndex !== 0) return;
    var r = el.getBoundingClientRect();
    if (r.bottom < 80 || r.top > window.innerHeight - 80) return;
    try { sessionStorage.setItem('dGalNudge', '1'); } catch (e) {}
    s.translateTo(-Math.round(s.width * 0.08), 380, false, false);
    setTimeout(function () {
      if (!s.destroyed && s.activeIndex === 0 && !touched) s.translateTo(0, 420, false, false);
    }, 600);
  }
  function start() { setTimeout(go, 900); }
  if (document.readyState === 'complete') start(); else window.addEventListener('load', start);
})();

/* Size guide: swipe left or right on the content to move between tabs, so
   shoppers on a phone don't have to reach up to the tab row (Johannes
   2026-10-10). Taps on the tabs keep working; inputs, videos and sideways
   scrollers keep their own touch. The new panel slides in from the swipe side. */
(function () {
  var sx = null, sy = 0;
  function guide() {
    var all = document.querySelectorAll('#v2-size-guide');
    for (var i = 0; i < all.length; i++) if (!all[i].hidden) return all[i];
    return null;
  }
  document.addEventListener('touchstart', function (e) {
    var g = guide();
    if (!g || e.touches.length > 1 || !g.contains(e.target) || !e.target.closest('.v2-sg__body')) { sx = null; return; }
    if (e.target.closest('input, textarea, select, video, [data-sg-noswipe]')) { sx = null; return; }
    // a real sideways scroller inside the panel keeps its own swipe (the body
    // itself only scrolls up and down; a slide-in can widen it for a moment)
    var body = e.target.closest('.v2-sg__body');
    for (var n = e.target; n && n !== body; n = n.parentElement) {
      if (n.scrollWidth > n.clientWidth + 24 && /(auto|scroll)/.test(getComputedStyle(n).overflowX)) { sx = null; return; }
    }
    sx = e.touches[0].clientX; sy = e.touches[0].clientY;
  }, { passive: true });
  document.addEventListener('touchend', function (e) {
    if (sx === null) return;
    var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy; sx = null;
    if (Math.abs(dx) < 50 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
    var g = guide(); if (!g) return;
    var tabs = [].slice.call(g.querySelectorAll('[data-sg-tab]')).filter(function (t) { return t.offsetParent !== null; });
    var cur = tabs.findIndex(function (t) { return t.getAttribute('aria-selected') === 'true'; });
    var next = tabs[cur + (dx < 0 ? 1 : -1)];
    if (!next) return;
    next.click();
    if (next.scrollIntoView) next.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
    var p = g.querySelector('[data-sg-panel="' + next.dataset.sgTab + '"]');
    if (p) { p.classList.remove('v2-sg-in-l', 'v2-sg-in-r'); void p.offsetWidth; p.classList.add(dx < 0 ? 'v2-sg-in-r' : 'v2-sg-in-l'); }
  }, { passive: true });
})();

/* Express shipping fee in the shopper's currency (Johannes 2026-10-10). The
   fee is set in euro in Shopify (€9,95). Other currencies get Shopify's own
   rate, rounded UP to a whole amount with no decimals (74,37 kr shows 75 kr),
   in the shop's money format for that currency (a sample of 1000 printed by
   the theme shows the separators). Rows can arrive later (the shipping panel
   is a template), so new ones are watched for. The shipping page carries the
   same logic inline (sections/drippy-shipping-page.liquid). */
(function () {
  var cur = (window.Shopify && Shopify.currency) || {};
  function fmt(v, sample, dec) {
    var m = sample && sample.match(/1([.,'   ]?)000(?:([.,])00)?/);
    var n = v.toFixed(dec).split('.');
    if (!m) return n.join('.');
    var dsep = m[2] || (/^en/i.test(document.documentElement.lang || 'en') ? '.' : ',');
    var whole = n[0].replace(/\B(?=(\d{3})+(?!\d))/g, m[1]);
    return sample.replace(m[0], whole + (dec ? dsep + n[1] : ''));
  }
  function paint(root) {
    var els = (root.querySelectorAll ? root : document).querySelectorAll('[data-ship-eur]:not([data-done])');
    for (var i = 0; i < els.length; i++) {
      var el = els[i]; el.setAttribute('data-done', '');
      var eur = !cur.active || cur.active === 'EUR';
      var rate = eur ? 1 : parseFloat(cur.rate);
      if (!rate) { el.style.visibility = ''; continue; }
      var v = parseInt(el.dataset.shipEur, 10) / 100 * rate;
      el.textContent = eur ? fmt(v, el.getAttribute('data-money-sample') || '', 2) : fmt(Math.ceil(v), el.getAttribute('data-money-sample') || '', 0);
      el.style.visibility = '';
    }
  }
  function start() {
    paint(document);
    if (window.MutationObserver) new MutationObserver(function (ms) {
      for (var i = 0; i < ms.length; i++) for (var j = 0; j < ms[i].addedNodes.length; j++) { var n = ms[i].addedNodes[j]; if (n.nodeType === 1 && (n.matches('[data-ship-eur]') || n.querySelector('[data-ship-eur]'))) paint(n.parentNode || n); }
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* Add to cart text roll on size change (Johannes 2026-10-10, after Represent):
   picking a size rolls the button text up and back in from below, so the
   shopper sees the button took the new size. Main button and sticky bar;
   skipped for reduced motion. Runs after the theme has updated the button
   (it can rewrite the label, e.g. to Sold out). */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  function roll() {
    var bs = document.querySelectorAll('.product-form__submit[name="add"]');
    for (var i = 0; i < bs.length; i++) {
      var b = bs[i], s = b.querySelector(':scope > span');
      if (!s || !b.offsetParent) continue;
      b.classList.add('d-atc-roll');
      s.classList.remove('d-atc-roll__t'); void s.offsetWidth; s.classList.add('d-atc-roll__t');
    }
  }
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || t.type !== 'radio' || !t.closest('.product__info-container, .product-parameters, variant-radios, variant-selects')) return;
    setTimeout(roll, 120);
  }, true);
})();

/* No pre-selected size (Johannes 2026-10-10). Unless the shopper arrived on a
   link with ?variant=, the size buttons start empty; the first tap picks one.
   Add to cart (main button and sticky bar) is held back until a size is
   picked: the size row shakes and scrolls into view instead. Products with a
   single size keep it selected. */
(function () {
  var nav = (performance.getEntriesByType && performance.getEntriesByType('navigation')[0]) || {};
  if (/[?&]variant=/.test(nav.name || location.search)) return;
  var need = false;
  function groups() {
    return [].slice.call(document.querySelectorAll('.product__info-container .product-parameters .product-form__controls'))
      .filter(function (f) { return f.querySelector('.size-guide-btn') && f.querySelectorAll('input[type="radio"]').length > 1; });
  }
  function clear() {
    var gs = groups(); if (!gs.length) return;
    need = true;
    gs.forEach(function (g) {
      [].slice.call(g.querySelectorAll('input[type="radio"]')).forEach(function (r) { r.checked = false; });
      var v = g.querySelector('.v2-optionvalue'); if (v) v.remove();
      var n = g.querySelector('.product-form__group-name'); if (n) delete n.dataset.v2Name;
    });
  }
  function hint() {
    var g = groups().filter(function (x) { return x.offsetParent !== null; })[0];
    if (!g) return;
    g.classList.remove('d-size-shake'); void g.offsetWidth; g.classList.add('d-size-shake');
    g.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.type === 'radio' && t.closest('.product-parameters') && t.closest('.product-form__controls') && t.closest('.product-form__controls').querySelector('.size-guide-btn')) need = false;
  }, true);
  function block(e) {
    if (!need) return;
    var b = e.target.closest && e.target.closest('.product-form__submit, button[name="add"]');
    if (e.type === 'click' && !b) return;
    if (e.type === 'submit' && !/^product-form-/.test((e.target && e.target.id) || '')) return;
    e.preventDefault(); e.stopImmediatePropagation(); hint();
  }
  document.addEventListener('click', block, true);
  document.addEventListener('submit', block, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', clear); else clear();
  // the theme can re-check its default after load; clear once more while nothing was picked
  window.addEventListener('load', function () { if (need) clear(); });
})();

/* Reviews line under the title (Johannes 2026-10-10): the Loox rating block
   moves from above the title to between the title row and the Klarna line;
   the CSS gives title, reviews and Klarna the same gap. */
(function () {
  function move() {
    var infos = document.querySelectorAll('.product__info-container');
    for (var i = 0; i < infos.length; i++) {
      var info = infos[i];
      var blk = info.querySelector('.shopify-app-block[id*="loox_rating"]');
      var title = info.querySelector('.v2-titlerow');
      if (!blk || !title || blk.dataset.dMoved) continue;
      // the grey spec line (2026-10-11) stays right under the title, reviews follow it
      var after = (title.nextElementSibling && title.nextElementSibling.classList.contains('d-specline')) ? title.nextElementSibling : title;
      title.parentNode.insertBefore(blk, after.nextSibling);
      blk.dataset.dMoved = '1';
      blk.classList.add('d-rating-under');
    }
  }
  move();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', move);
  window.addEventListener('load', move);
})();


/* Stock status next to the picked size (Johannes 2026-10-10): green "In stock",
   orange "Only n left" when fewer than 30 are left, red "Sold out". Counts and
   strings come from #d-stock-data in pdp-v2-data. Nothing shows until a size
   is picked. Built as nodes; runs after paint(), which rebuilds the label. */
(function () {
  var src = document.getElementById('d-stock-data');
  if (!src) return;
  var D;
  try { D = JSON.parse(src.textContent); } catch (e) { return; }
  var LOW = 30;
  function sizeGroup() {
    return document.querySelector('.product__info-container .product-parameters .product-form__controls .size-guide-btn');
  }
  function update() {
    var btn = sizeGroup();
    var fs = btn && btn.closest('.product-form__controls');
    if (!fs) return;
    var name = fs.querySelector('.product-form__group-name');
    if (!name) return;
    var box = fs.closest('variant-radios, variant-selects');
    var checked = fs.querySelector('input[type="radio"]:checked');
    var id = null;
    if (checked && box) {
      var vs = [];
      try { vs = JSON.parse((box.querySelector('script[data-all-variants-no-high]') || {}).textContent || '[]'); } catch (e) {}
      var picked = [].slice.call(box.querySelectorAll('.product-form__controls')).map(function (f) {
        var c = f.querySelector('input[type="radio"]:checked');
        return { pos: +(f.dataset.optionPosition || 0), val: c ? c.value : null };
      });
      for (var i = 0; i < vs.length && id === null; i++) {
        var ok = picked.every(function (p) { return !p.pos || p.val === null || vs[i]['option' + p.pos] === p.val; });
        if (ok) id = vs[i].id;
      }
    }
    var q = id !== null ? D.v[String(id)] : undefined;
    var old = name.querySelector('.d-stock');
    [].slice.call(fs.querySelectorAll('label[data-d-stock]')).forEach(function (l) { delete l.dataset.dStock; });
    if (q === undefined) { if (old) old.remove(); return; }
    // 2026-10-25: a size sold out at TRL that ships from Keizersgracht reads "Backorder" (NL/BE/DE)
    var bo = !!(D.b && D.b[String(id)]);
    var cls = bo ? 'bo' : q <= 0 ? 'out' : q < LOW ? 'low' : 'in';
    var lab = fs.querySelector('label[for="' + checked.id + '"]');
    if (lab) lab.dataset.dStock = cls;
    var text = bo ? D.t.bo : q <= 0 ? D.t.out : q < LOW ? (q === 1 ? D.t.one : D.t.other.replace('[n]', q)) : D.t['in'];
    if (old && old.textContent === text) return;
    if (old) old.remove();
    var s = document.createElement('span');
    s.className = 'd-stock d-stock--' + cls;
    s.textContent = text;
    name.appendChild(s);
  }
  document.addEventListener('change', function (e) {
    if (e.target && e.target.type === 'radio') setTimeout(update, 0);
  });
  // paint() can rebuild the label after a re-render; put the status back
  var t = null;
  function watch() {
    var info = document.querySelector('.product__info-container .product-parameters');
    if (!info || !window.MutationObserver) return;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(update, 60); })
      .observe(info, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { update(); watch(); });
  else { update(); watch(); }
  window.addEventListener('load', function () { setTimeout(update, 50); });
})();


/* Mobile slider bar (Johannes 2026-10-11): black on the first slide, which is
   the light packshot; white from slide 2 on, where the photos are dark, so the
   bar stays visible. Watches the active bullet instead of swiper events. */
(function () {
  function bind() {
    var wraps = document.querySelectorAll('.product__pagination-mobile_sliding_bar-wrapper');
    for (var i = 0; i < wraps.length; i++) {
      var w = wraps[i];
      if (w.dataset.dBar) continue;
      w.dataset.dBar = '1';
      (function (w) {
        function sync() {
          var bs = w.querySelectorAll('.swiper-pagination-bullet');
          var first = bs.length && bs[0].classList.contains('swiper-pagination-bullet-active');
          w.classList.toggle('d-bar-light', bs.length > 0 && !first);
        }
        sync();
        new MutationObserver(sync).observe(w, { subtree: true, attributes: true, attributeFilter: ['class'], childList: true });
      })(w);
    }
  }
  bind();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind);
  window.addEventListener('load', bind);
})();


/* Reviews sheet (Johannes 2026-10-11, option B): the stars under the title open
   a bottom sheet (mobile) / right drawer (desktop) instead of scrolling down:
   rating, the reviews summary, customer photos, the best reviews first, and Add
   to cart with the picked size. Live for all products since 2026-10-11. */
(function () {
  var src = document.getElementById('d-rsheet-data');
  if (!src) return;
  var D; try { D = JSON.parse(src.textContent); } catch (e) { return; }
  var feed = (D.feed && D.feed.reviews) || [];
  var textOnly = false;
  // written reviews carry no language tag; a small stop-word guess puts the visitor's language first
  var LW = { en: /\b(the|and|is|it|very|great|love|my|with|this)\b/gi, nl: /\b(het|en|is|een|zeer|mooi|heel|mijn|met|de)\b/gi, de: /\b(und|ist|sehr|schön|die|der|mein|mit|ich|das)\b/gi, fr: /\b(et|est|très|le|la|mon|avec|je|une|beau)\b/gi, it: /\b(e|è|molto|il|la|mio|con|bello|una|che)\b/gi, es: /\b(y|es|muy|el|la|mi|con|bonito|una|que)\b/gi, pt: /\b(e|é|muito|o|a|meu|com|lindo|uma|que)\b/gi, sv: /\b(och|är|mycket|det|min|med|jag|en|fin|snygg)\b/gi, da: /\b(og|er|meget|det|min|med|jeg|en|flot|smuk)\b/gi };
  function guess(t) { var best = null, n = 0; for (var k in LW) { var m = (t.match(LW[k]) || []).length; if (m > n) { n = m; best = k; } } return best; }
  if (!feed.length && D.html) {
    // fallback: Loox's written-review list, no star per review, so stricter filtering below
    textOnly = true;
    var doc = new DOMParser().parseFromString(D.html, 'text/html');
    feed = [].slice.call(doc.querySelectorAll('.review')).map(function (n) {
      var nm = n.querySelector('.name'), tx = n.querySelector('.review_text');
      var txt = tx ? tx.textContent.trim() : '';
      return { author: nm ? nm.textContent.trim() : '', review: txt, rating: 0, media: [], language: guess(txt) };
    });
  }
  if (!feed.length) return;
  var NEG = /\b(not|no|never|bad|poor|cheap|fake|but|however|nicht|kein|aber|schlecht|niet|geen|maar|slecht|pas|mais|mauvais|non|ma|male|no|pero|malo|não|mas|mau|inte|men|dålig|ikke|dårlig)\b|disappoint|enttäusch|teleurgesteld|déçu|deluso|decepcion|decepcion|skuffet|besviken/i;
  var T = D.t || {};
  var lang = (document.documentElement.lang || 'en').slice(0, 2);
  var BAD = /deliver|shipping|arriv|late|lost|custom|tax|refund|return|broke|fade|tarnish|green|rust|missing|wrong|disappoint|smaller|bigger|too small|too big|lieferung|versand|zoll|kaputt|verloren|zurück|levering|bezorg|douane|kapot|kwijt|retour|livraison|cass|perdu|envío|envio|roto|perdid|consegna|spedizione|rotto|perso|leveran|levering|ødelagt|trasig/i;
  function score(r) {
    var t = (r.review || '').trim(), s = 0;
    if (textOnly) s += NEG.test(t) ? -999 : 100; else s += r.rating === 5 ? 100 : r.rating === 4 ? 40 : -999;
    if (BAD.test(t)) s -= 999;
    if (r.language === lang) s += 30; else if (r.language === 'en') s += 12;
    if (textOnly && t.length < 12) s -= 999;
    var m = r.media || [];
    if (m.some(function (x) { return x.t === 'photo'; })) s += 6;
    var n = t.length; s += n >= 40 && n <= 220 ? 15 : n > 220 ? 8 : n < 15 ? -20 : 0;
    if (r.verified) s += 3;
    return s;
  }
  var list = feed.filter(function (r) { return score(r) > 0; }).sort(function (a, b) { return score(b) - score(a); }).slice(0, 25);
  var photos = [];
  // Loox stores only a poster (with a play icon baked in) for video reviews, not a playable file, so only real photos show
  list.forEach(function (r) { r.media = (r.media || []).filter(function (m) { return m.t === 'photo'; }); r.media.forEach(function (m) { if (photos.length < 12) photos.push(m); }); });
  // 2026-10-13 (Johannes): the strip shows every good customer photo, not only those of the top 25 reviews.
  // custom.review_photos (built from the product's own Loox reviews, wrong-product photos removed) wins when set.
  if (Array.isArray(D.photos)) photos = D.photos.slice(0, 16).map(function (s) { return { t: 'photo', src: s }; });
  else { photos = []; feed.forEach(function (r) { if ((r.rating || 0) >= 4 && !BAD.test(r.review || '')) (r.media || []).forEach(function (m) { if (m.t === 'photo' && photos.length < 16) photos.push(m); }); }); }
  // below the strip: the real Loox widget (translated, every review, review photos) with its own header cropped off
  var looxEl = document.getElementById('looxReviews'), looxHome = null;
  function img(m, w) { return (m.src.indexOf('//') === 0 ? 'https:' : '') + m.src.replace('_mid.', '_mid.') ; }
  function esc(s) { return String(s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  var STAR = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m12 2.8 2.8 5.9 6.4.8-4.7 4.4 1.2 6.4L12 17.2 6.3 20.3l1.2-6.4L2.8 9.5l6.4-.8z" fill="currentColor"/></svg>';
  function stars(n) { var o = ''; for (var i = 0; i < 5; i++) o += '<span class="' + (i < n ? 'on' : '') + '">' + STAR + '</span>'; return o; }
  var avg = Number(D.avg || 0), num = Number(D.count || 0);
  var numTxt = num.toLocaleString(document.documentElement.lang || 'en');
  var avgTxt = avg.toLocaleString(document.documentElement.lang || 'en', { minimumFractionDigits: 1, maximumFractionDigits: 1 });

  var root = document.createElement('div');
  root.className = 'drs'; root.hidden = true;
  root.innerHTML =
    '<div class="drs__dim" data-drs-close></div>' +
    '<section class="drs__panel" role="dialog" aria-modal="true" aria-label="' + esc(T.title) + '">' +
      '<div class="drs__grab" data-drs-grab><span></span></div>' +
      '<header class="drs__head" data-drs-grab><div class="drs__score"><b>' + avgTxt + '</b><div><div class="drs__stars">' + stars(Math.round(avg)) + '</div><small>' + numTxt + ' ' + esc(T.reviews) + '</small></div></div>' +
      '<button type="button" class="drs__x" data-drs-close aria-label="' + esc(T.close) + '"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg></button></header>' +
      '<div class="drs__body">' +
        '<div class="drs__sumwrap" data-drs-sum></div>' +
        '<div class="drs__strip" data-drs-strip></div>' +
        (looxEl ? '<div class="drs__loox" data-drs-loox></div>' : '') + (looxEl ? '' : '<div class="drs__list">' + list.map(function (r) {
          var m = (r.media || []).slice(0, 3).map(function (x) { return '<button type="button" class="drs__th" data-drs-zoom="' + esc(img(x)) + '"><img loading="lazy" src="' + esc(img(x)) + '" alt=""></button>'; }).join('');
          return '<article class="drs__rv">' + (textOnly ? '' : '<div class="drs__stars drs__stars--sm">' + stars(r.rating) + '</div>') + '<p>' + esc(r.review) + '</p>' + (m ? '<div class="drs__ths">' + m + '</div>' : '') +
            '<small>' + esc(r.author) + (r.verified ? ' · ' + esc(T.verified) : '') + '</small></article>';
        }).join('') + '</div>') +
      '</div>' +
      '<footer class="drs__foot"><span class="drs__size" data-drs-size></span><button type="button" class="drs__atc" data-drs-atc></button></footer>' +
      '<div class="drs__zoom" data-drs-zoomview hidden><img alt=""></div>' +
    '</section>';
  document.body.appendChild(root);

  var pageSum = document.querySelector('.v2-rsum');
  if (pageSum) { var cl = pageSum.cloneNode(true); cl.removeAttribute('id'); root.querySelector('[data-drs-sum]').appendChild(cl); }
  else if (D.summary) root.querySelector('[data-drs-sum]').innerHTML = '<p class="drs__sum">' + esc(D.summary) + '</p>';
  var strip = root.querySelector('[data-drs-strip]');
  var vidBtn = document.querySelector('[data-dvid-open]');
  var vidPoster = document.querySelector('.dvid__item video');
  var html = '';
  if (vidBtn && vidPoster) html += '<button type="button" class="drs__tile drs__tile--vid" data-drs-vid><img src="' + esc(vidPoster.getAttribute('poster')) + '" alt=""><span><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8.5 5.5v13l10-6.5z" fill="currentColor"/></svg>' + esc(T.videos) + '</span></button>';
  photos.forEach(function (m) { html += '<button type="button" class="drs__tile" data-drs-zoom="' + esc(img(m)) + '"><img loading="lazy" src="' + esc(img(m)) + '" alt=""></button>'; });
  // 2026-10-18 (Jo): no customer photo / video strip in the drawer any more; only the summary and the Loox widget.
  strip.remove();

  var panel = root.querySelector('.drs__panel'), zoom = root.querySelector('[data-drs-zoomview]');
  function mainBtn() { return document.querySelector('.product__info-container form[action*="/cart/add"] [name="add"]') || document.querySelector('form[action*="/cart/add"] [type="submit"]'); }
  function sizeTxt() {
    var c = document.querySelector('.product__info-container .product-form__controls:not(.d-single) input[type="radio"]:checked');
    return c && document.querySelector('.product__info-container .product-form__controls:not(.d-single) .size-guide-btn') ? (c.closest('label') ? '' : '') + (c.dataset.dLabel || c.value || '') : '';
  }
  function syncFoot() {
    var b = mainBtn(), a = root.querySelector('[data-drs-atc]');
    a.textContent = b ? (b.querySelector('span') ? b.querySelector('span').textContent : b.textContent).trim() : '';
    var lab = document.querySelector('.product__info-container .product-form__controls .v2-optionvalue');
    root.querySelector('[data-drs-size]').textContent = lab ? lab.textContent.trim() : '';
  }
  var lastY = 0;
  function open() {
    syncFoot(); lastY = window.scrollY;
    if (looxEl && !looxHome) { looxHome = document.createComment('loox'); looxEl.parentNode.insertBefore(looxHome, looxEl); root.querySelector('[data-drs-loox]').appendChild(looxEl); }
    root.hidden = false; document.documentElement.classList.add('drs-lock');
    void root.offsetWidth; setTimeout(function () { root.classList.add('is-open'); }, 20);
  }
  function close() {
    root.classList.remove('is-open'); document.documentElement.classList.remove('drs-lock');
    zoom.hidden = true; panel.style.transform = '';
    setTimeout(function () { root.hidden = true; if (looxHome) { looxHome.parentNode.insertBefore(looxEl, looxHome); looxHome.remove(); looxHome = null; } }, 280);
  }
  root.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-drs-close]')) { close(); return; }
    var z = t.closest('[data-drs-zoom]');
    if (z) { zoom.querySelector('img').src = z.dataset.drsZoom; zoom.hidden = false; return; }
    if (t.closest('[data-drs-zoomview]')) { zoom.hidden = true; return; }
    if (t.closest('[data-drs-vid]')) { close(); setTimeout(function () { vidBtn.click(); }, 300); return; }
    if (t.closest('[data-drs-atc]')) {
      var b = mainBtn();
      if (!b) return;
      if (b.disabled || b.getAttribute('aria-disabled') === 'true') {
        close(); var s = document.querySelector('.product__info-container .product-parameters');
        if (s) s.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      close(); setTimeout(function () { b.click(); }, 150);
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !root.hidden) close(); });
  // swipe down on the handle/header closes the sheet (mobile)
  var y0 = null;
  root.querySelectorAll('[data-drs-grab]').forEach(function (g) {
    g.addEventListener('touchstart', function (e) { y0 = e.touches[0].clientY; }, { passive: true });
    g.addEventListener('touchmove', function (e) { if (y0 === null) return; var d = e.touches[0].clientY - y0; if (d > 0) panel.style.transform = 'translateY(' + d + 'px)'; }, { passive: true });
    g.addEventListener('touchend', function (e) { if (y0 === null) return; var d = e.changedTouches[0].clientY - y0; y0 = null; if (d > 90) close(); else panel.style.transform = ''; });
  });
  // stars under the title open the sheet instead of scrolling down
  document.addEventListener('click', function (e) {
    var t = e.target.closest('.d-rating-under, .product__info-container .loox-rating, [data-d-rv-open]');
    if (!t) return;
    e.preventDefault(); e.stopPropagation(); open();
  }, true);
})();

/* 2026-10-13 (Johannes): Shipping & returns rows show estimated dates instead of
   working days, same rules as the line under Add to cart (snippets/drippy-eta).
   The panel is filled from a <template> when it opens, so new rows are picked
   up as they appear; each row is done once, so filling it never retriggers. */
(function () {
  function fill(el) {
    el.setAttribute('data-dd-done', '');
    try {
      var p = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Amsterdam', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date()).split('-');
      var d = new Date(Date.UTC(+p[0], +p[1] - 1, +p[2], 12));
      var wk = function (x) { var g = x.getUTCDay(); return g === 0 || g === 6; };
      if (el.hasAttribute('data-kg')) {
        d.setUTCDate(d.getUTCDate() + 1);
        if (d.getUTCDay() === 0) d.setUTCDate(d.getUTCDate() + 1);
        wk = function (x) { return x.getUTCDay() === 0; };
      } else {
        while (wk(d)) d.setUTCDate(d.getUTCDate() + 1);
      }
      var add = function (n) { var x = new Date(d); while (n > 0) { x.setUTCDate(x.getUTCDate() + 1); if (!wk(x)) n--; } return x; };
      var loc = el.dataset.locale || 'en', mn = +el.dataset.min, mx = +el.dataset.max;
      var fs = new Intl.DateTimeFormat(loc, { month: 'short', day: 'numeric', timeZone: 'UTC' });
      var html;
      if ((el.dataset.country === 'NL' || el.dataset.country === 'BE') && !el.hasAttribute('data-kg')) {
        var due = new Date(Date.UTC(+p[0], +p[1] - 1, +p[2] + 1, 12)), next = new Date(due);
        while (wk(due)) due.setUTCDate(due.getUTCDate() + 1);
        var word = due.getTime() === next.getTime() ? new Intl.RelativeTimeFormat(loc, { numeric: 'auto' }).format(1, 'day') : new Intl.DateTimeFormat(loc, { weekday: 'long', timeZone: 'UTC' }).format(due);
        html = el.dataset.singleT.replace('%F', word);
      } else if (mn === mx) {
        html = el.dataset.singleT.replace('%F', fs.format(add(mx)));
      } else {
        html = el.dataset.rangeT.replace('%A', fs.format(add(mn))).replace('%B', fs.format(add(mx)));
      }
      el.innerHTML = html;
    } catch (e) {}
  }
  function scan() { [].slice.call(document.querySelectorAll('[data-dd]:not([data-dd-done])')).forEach(fill); }
  var busy = false;
  new MutationObserver(function () {
    if (busy || !document.querySelector('[data-dd]:not([data-dd-done])')) return;
    busy = true; scan(); busy = false;
  }).observe(document.documentElement, { childList: true, subtree: true });
  scan();
})();
